/* Source: /home/runner/work/jaseci-blogs/jaseci-blogs/pages/blog/posts/[slug].jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useParams, Link } from "@jac/runtime";
import { useRef } from "react";
import { useState } from "@jac/runtime";
import { useEffect } from "@jac/runtime";
const _jac = {
  int: {
    bit_length(n) {
      if (n === 0) return 0;
      return Math.floor(Math.log2(Math.abs(n))) + 1;
    },
    bit_count(n) {
      let x = Math.abs(n);
      let count = 0;
      while (x) { count += x & 1; x >>= 1; }
      return count;
    },
    to_bytes(n, length, byteorder) {
      const bytes = [];
      let val = n < 0 ? (1 << (length * 8)) + n : n;
      for (let i = 0; i < length; i++) {
        bytes.push(val & 0xff);
        val >>= 8;
      }
      if (byteorder === "big") bytes.reverse();
      return bytes;
    },
    from_bytes(bytes, byteorder) {
      const b = byteorder === "big" ? bytes : [...bytes].reverse();
      let result = 0;
      for (const byte of b) result = (result << 8) | byte;
      return result;
    },
    mod(a, b) { return ((a % b) + b) % b; }
  },

  float: {
    as_integer_ratio(f) {
      if (!isFinite(f)) throw new _jac.exc.ValueError("cannot convert " + f + " to integer ratio");
      if (f === 0) return [0, 1];
      let num = f, den = 1;
      while (num !== Math.floor(num)) { num *= 2; den *= 2; }
      const g = _jac.float._gcd(Math.abs(num), den);
      return [num / g, den / g];
    },
    _gcd(a, b) { while (b) { [a, b] = [b, a % b]; } return a; },
    hex(f) {
      return f.toString(16);
    },
    fromhex(s) {
      return parseFloat(s);
    },
    mod(a, b) { return ((a % b) + b) % b; }
  },

  complex: {
    conjugate(c) { return {re: c.re, im: -c.im}; },
    add(a, b) { return {re: a.re + b.re, im: a.im + b.im}; },
    sub(a, b) { return {re: a.re - b.re, im: a.im - b.im}; },
    mul(a, b) { return {re: a.re * b.re - a.im * b.im, im: a.re * b.im + a.im * b.re}; },
    truediv(a, b) {
      const d = b.re * b.re + b.im * b.im;
      return {re: (a.re * b.re + a.im * b.im) / d, im: (a.im * b.re - a.re * b.im) / d};
    },
    pow(a, b) {
      if (typeof b === "number") b = {re: b, im: 0};
      if (typeof a === "number") a = {re: a, im: 0};
      if (b.im === 0 && Number.isInteger(b.re)) {
        let result = {re: 1, im: 0};
        for (let i = 0; i < Math.abs(b.re); i++) result = _jac.complex.mul(result, a);
        return b.re < 0 ? _jac.complex.truediv({re: 1, im: 0}, result) : result;
      }
      const r = Math.sqrt(a.re * a.re + a.im * a.im);
      const theta = Math.atan2(a.im, a.re);
      const lnr = Math.log(r);
      const newR = Math.exp(lnr * b.re - theta * b.im);
      const newTheta = lnr * b.im + theta * b.re;
      return {re: newR * Math.cos(newTheta), im: newR * Math.sin(newTheta)};
    },
    eq(a, b) {
      if (typeof b === "number") b = {re: b, im: 0};
      if (typeof a === "number") a = {re: a, im: 0};
      return a.re === b.re && a.im === b.im;
    },
    neg(a) { return {re: -a.re, im: -a.im}; },
    pos(a) { return {re: +a.re, im: +a.im}; }
  },

  str: {
    capitalize(s) {
      if (s.length === 0) return s;
      return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    },
    title(s) {
      return s.replace(/\b\w/g, c => c.toUpperCase());
    },
    swapcase(s) {
      return [...s].map(c => c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase()).join("");
    },
    count(s, sub, start, end) {
      const t = s.slice(start || 0, end);
      if (sub === "") return t.length + 1;
      let count = 0, pos = 0;
      while ((pos = t.indexOf(sub, pos)) !== -1) { count++; pos += sub.length; }
      return count;
    },
    find(s, sub, start, end) {
      const t = s.slice(start || 0, end);
      const idx = t.indexOf(sub);
      return idx === -1 ? -1 : idx + (start || 0);
    },
    rfind(s, sub, start, end) {
      const t = s.slice(start || 0, end);
      const idx = t.lastIndexOf(sub);
      return idx === -1 ? -1 : idx + (start || 0);
    },
    index(s, sub, start, end) {
      const idx = _jac.str.find(s, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    rindex(s, sub, start, end) {
      const idx = _jac.str.rfind(s, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    startswith(s, prefix, start, end) {
      return s.slice(start || 0, end).startsWith(prefix);
    },
    endswith(s, suffix, start, end) {
      return s.slice(start || 0, end).endsWith(suffix);
    },
    replace(s, old, new_, count) {
      if (count === undefined) return s.split(old).join(new_);
      let result = s, n = 0;
      while (n < count) {
        const idx = result.indexOf(old);
        if (idx === -1) break;
        result = result.slice(0, idx) + new_ + result.slice(idx + old.length);
        n++;
      }
      return result;
    },
    strip(s, chars) {
      if (!chars) return s.trim();
      let start = 0, end = s.length;
      while (start < end && chars.indexOf(s[start]) !== -1) start++;
      while (end > start && chars.indexOf(s[end - 1]) !== -1) end--;
      return s.slice(start, end);
    },
    lstrip(s, chars) {
      if (!chars) return s.trimStart();
      let start = 0;
      while (start < s.length && chars.indexOf(s[start]) !== -1) start++;
      return s.slice(start);
    },
    rstrip(s, chars) {
      if (!chars) return s.trimEnd();
      let end = s.length;
      while (end > 0 && chars.indexOf(s[end - 1]) !== -1) end--;
      return s.slice(0, end);
    },
    removeprefix(s, prefix) {
      return s.startsWith(prefix) ? s.slice(prefix.length) : s;
    },
    removesuffix(s, suffix) {
      return (suffix && s.endsWith(suffix)) ? s.slice(0, -suffix.length) : s;
    },
    split(s, sep, maxsplit) {
      if (sep === undefined || sep === null) {
        const parts = s.trim().split(/\s+/);
        if (maxsplit === undefined) return parts;
        if (maxsplit <= 0) return [s];
        return [...parts.slice(0, maxsplit), parts.slice(maxsplit).join(" ")].filter(x => x !== undefined);
      }
      if (maxsplit === undefined) return s.split(sep);
      const parts = s.split(sep);
      if (parts.length <= maxsplit + 1) return parts;
      return [...parts.slice(0, maxsplit), parts.slice(maxsplit).join(sep)];
    },
    rsplit(s, sep, maxsplit) {
      if (maxsplit === undefined) return _jac.str.split(s, sep);
      const parts = s.split(sep);
      if (parts.length <= maxsplit + 1) return parts;
      const keep = parts.length - maxsplit;
      return [parts.slice(0, keep).join(sep), ...parts.slice(keep)];
    },
    splitlines(s, keepends) {
      const lines = s.split(/(\r\n|\r|\n)/);
      const result = [];
      for (let i = 0; i < lines.length; i += 2) {
        const line = lines[i];
        const sep = lines[i + 1] || "";
        if (line || sep) result.push(keepends ? line + sep : line);
      }
      return result;
    },
    partition(s, sep) {
      const idx = s.indexOf(sep);
      if (idx === -1) return [s, "", ""];
      return [s.slice(0, idx), sep, s.slice(idx + sep.length)];
    },
    rpartition(s, sep) {
      const idx = s.lastIndexOf(sep);
      if (idx === -1) return ["", "", s];
      return [s.slice(0, idx), sep, s.slice(idx + sep.length)];
    },
    format(s, ...args) {
      let i = 0;
      return s.replace(/\{(\w*)\}/g, (match, key) => {
        if (key === "") return args[i++];
        if (!isNaN(key)) return args[parseInt(key)];
        return args[0] && typeof args[0] === "object" ? args[0][key] : match;
      });
    },
    format_map(s, mapping) {
      return s.replace(/\{(\w+)\}/g, (match, key) => key in mapping ? mapping[key] : match);
    },
    center(s, width, fillchar) {
      const fc = fillchar || " ";
      if (s.length >= width) return s;
      const total = width - s.length;
      const left = Math.floor(total / 2);
      return fc.repeat(left) + s + fc.repeat(total - left);
    },
    zfill(s, width) {
      if (s.length >= width) return s;
      const sign = (s[0] === "+" || s[0] === "-") ? s[0] : "";
      const body = sign ? s.slice(1) : s;
      return sign + "0".repeat(width - s.length) + body;
    },
    expandtabs(s, tabsize) {
      const ts = tabsize === undefined ? 8 : tabsize;
      let result = "", col = 0;
      for (const c of s) {
        if (c === "\t") { const sp = ts - (col % ts); result += " ".repeat(sp); col += sp; }
        else if (c === "\n" || c === "\r") { result += c; col = 0; }
        else { result += c; col++; }
      }
      return result;
    },
    isnumeric(s) {
      if (s.length === 0) return false;
      return [...s].every(c => /[\d\u00B2\u00B3\u00B9\u00BC-\u00BE\u2150-\u218F]/.test(c));
    },
    istitle(s) {
      return s === _jac.str.title(s) && /[A-Za-z]/.test(s);
    },
    translate(s, table) {
      return [...s].map(c => {
        const code = c.charCodeAt(0);
        if (code in table) {
          const v = table[code];
          if (v === null) return "";
          if (typeof v === "number") return String.fromCharCode(v);
          return v;
        }
        return c;
      }).join("");
    },
    maketrans(...args) {
      const table = {};
      if (args.length === 1) {
        const mapping = args[0];
        for (const [k, v] of Object.entries(mapping)) {
          table[typeof k === "string" ? k.charCodeAt(0) : k] = v;
        }
      } else if (args.length >= 2) {
        const from_ = args[0], to_ = args[1];
        for (let i = 0; i < from_.length; i++) {
          table[from_.charCodeAt(i)] = to_.charCodeAt(i);
        }
        if (args[2]) {
          for (const c of args[2]) table[c.charCodeAt(0)] = null;
        }
      }
      return table;
    },
    mod(s, args) {
      let i = 0;
      const a = Array.isArray(args) ? args : [args];
      return s.replace(/%([sd%])/g, (m, fmt) => {
        if (fmt === "%") return "%";
        return String(a[i++]);
      });
    }
  },

  // Runtime-polymorphic method dispatch, used when the codegen cannot prove
  // the static type of a method-call receiver (e.g. a `dict`-typed prop, the
  // result of `or` widening, or a comprehension over an untyped value) and so
  // cannot pick a typed emitter. The compiler emits
  // `_jac.poly.call(obj, "name", ...args)`; `call` resolves the *runtime* type
  // of `obj` and applies the matching Python operation, forwards to a
  // same-named method on a user-defined object, or raises AttributeError. The
  // per-type tables below carry the trivial native-mapped methods inline and
  // delegate the non-trivial ones to the shared `_jac.str/list/dict/set`
  // helpers, so each operation has a single implementation and no Python
  // method name can leak verbatim into the emitted JavaScript.
  poly: {
    _typename(o) {
      if (o === null || o === undefined) return "NoneType";
      if (Array.isArray(o)) return "list";
      if (o instanceof Set) return "set";
      if (o instanceof Map) return "dict";
      if (o instanceof Uint8Array) return "bytes";
      const t = typeof o;
      if (t === "string") return "str";
      if (t === "boolean") return "bool";
      if (t === "number") return Number.isInteger(o) ? "int" : "float";
      if (t === "object") return (o.constructor && o.constructor.name) || "object";
      return t;
    },
    // --- per-runtime-type Python method tables (keyed by Python name) ---
    // Trivial native-mapped ops are inline; non-trivial ones delegate to the
    // shared `_jac.<type>` helpers (which the typed emitters also use), so the
    // typed and polymorphic paths share one implementation.
    _str: {
      lower: (s) => s.toLowerCase(),
      upper: (s) => s.toUpperCase(),
      casefold: (s) => s.toLowerCase(),
      strip: (s, chars) => {
        if (chars === undefined) return s.trim();
        let i = 0, j = s.length;
        while (i < j && chars.indexOf(s[i]) !== -1) i++;
        while (j > i && chars.indexOf(s[j - 1]) !== -1) j--;
        return s.slice(i, j);
      },
      lstrip: (s, chars) => {
        if (chars === undefined) return s.replace(/^\s+/, "");
        let i = 0;
        while (i < s.length && chars.indexOf(s[i]) !== -1) i++;
        return s.slice(i);
      },
      rstrip: (s, chars) => {
        if (chars === undefined) return s.replace(/\s+$/, "");
        let j = s.length;
        while (j > 0 && chars.indexOf(s[j - 1]) !== -1) j--;
        return s.slice(0, j);
      },
      join: (s, parts) => Array.from(parts, x => String(x)).join(s)
    },
    _list: {
      append: (a, x) => { a.push(x); return null; },
      clear: (a) => { a.length = 0; return null; },
      copy: (a) => a.slice(),
      count: (a, x) => _jac.list.count(a, x),
      extend: (a, b) => { for (const v of b) a.push(v); return null; },
      index: (a, x, start, end) => _jac.list.index(a, x, start, end),
      insert: (a, i, x) => { a.splice(i, 0, x); return null; },
      pop: (a, i) => {
        if (i === undefined) return a.pop();
        const idx = i < 0 ? a.length + i : i;
        return a.splice(idx, 1)[0];
      },
      remove: (a, x) => _jac.list.remove(a, x),
      reverse: (a) => { a.reverse(); return null; },
      sort: (a, key) => _jac.list.sort(a, key)
    },
    _dict: {
      clear: (o) => _jac.dict.clear(o),
      copy: (o) => ({ ...o }),
      // Python `dict.get`: returns the stored value when the key is present
      // (even if it is null), and the default only when the key is absent.
      // A membership check is required — `o[key] ?? default_` would wrongly
      // substitute the default for a present-but-null value.
      get: (o, key, default_) =>
        Object.prototype.hasOwnProperty.call(o, key) ? o[key] : default_,
      items: (o) => Object.entries(o),
      keys: (o) => Object.keys(o),
      pop: (o, key, default_) => _jac.dict.pop(o, key, default_),
      popitem: (o) => _jac.dict.popitem(o),
      setdefault: (o, key, default_) => _jac.dict.setdefault(o, key, default_),
      update: (o, other) => {
        if (other instanceof Map) { for (const [k, v] of other) o[k] = v; }
        else if (Array.isArray(other)) { for (const [k, v] of other) o[k] = v; }
        else if (other) { for (const k of Object.keys(other)) o[k] = other[k]; }
        return null;
      },
      values: (o) => Object.values(o)
    },
    _set: {
      add: (s, x) => { s.add(x); return null; },
      clear: (s) => { s.clear(); return null; },
      copy: (s) => new Set(s),
      difference: (a, b) => _jac.set.difference(a, b),
      difference_update: (s, o) => _jac.set.difference_update(s, o),
      discard: (s, x) => { s.delete(x); return null; },
      intersection: (a, b) => _jac.set.intersection(a, b),
      intersection_update: (s, o) => _jac.set.intersection_update(s, o),
      isdisjoint: (a, b) => _jac.set.isDisjointFrom(a, b instanceof Set ? b : new Set(b)),
      issubset: (a, b) => _jac.set.isSubsetOf(a, b instanceof Set ? b : new Set(b)),
      issuperset: (a, b) => _jac.set.isSupersetOf(a, b instanceof Set ? b : new Set(b)),
      pop: (s) => _jac.set.pop(s),
      remove: (s, x) => _jac.set.remove(s, x),
      symmetric_difference: (a, b) => _jac.set.symmetricDifference(a, b),
      symmetric_difference_update: (s, o) => _jac.set.symmetric_difference_update(s, o),
      union: (a, b) => _jac.set.union(a, b),
      update: (s, o) => _jac.set.update(s, o)
    },
    // Jac dicts compile to plain objects, but interop code may hand us a real
    // Map; mirror the dict methods over the Map API for that case.
    _map: {
      clear: (m) => { m.clear(); return null; },
      copy: (m) => new Map(m),
      get: (m, key, default_) => (m.has(key) ? m.get(key) : default_),
      items: (m) => [...m.entries()],
      keys: (m) => [...m.keys()],
      pop: (m, key, default_) => {
        if (m.has(key)) { const v = m.get(key); m.delete(key); return v; }
        if (default_ !== undefined) return default_;
        throw new _jac.exc.KeyError("KeyError: " + key);
      },
      popitem: (m) => {
        if (m.size === 0) throw new _jac.exc.KeyError("dictionary is empty");
        const key = [...m.keys()].pop();
        const val = m.get(key);
        m.delete(key);
        return [key, val];
      },
      setdefault: (m, key, default_) => {
        if (!m.has(key)) m.set(key, default_ === undefined ? null : default_);
        return m.get(key);
      },
      update: (m, other) => {
        if (other instanceof Map) { for (const [k, v] of other) m.set(k, v); }
        else if (Array.isArray(other)) { for (const [k, v] of other) m.set(k, v); }
        else if (other) { for (const k of Object.keys(other)) m.set(k, other[k]); }
        return null;
      },
      values: (m) => [...m.values()]
    },
    // Single entry point. `obj.method(...args)` on a receiver whose static
    // type is not provably primitive is compiled to
    // `_jac.poly.call(obj, "method", ...args)`.
    call(o, m, ...args) {
      // 1. Genuine JS primitives get Python-semantic dispatch: a plain object
      //    is a Python dict, an Array is a list, a Set/Map/string/number/bytes
      //    maps to its Python counterpart. These are the types whose Python
      //    method semantics differ from (or have no) native JS equivalent.
      if (typeof o === "string") {
        if (_jac.poly._str[m]) return _jac.poly._str[m](o, ...args);
        if (_jac.str[m]) return _jac.str[m](o, ...args);
      } else if (typeof o === "number") {
        const ns = Number.isInteger(o) ? _jac.int : _jac.float;
        if (ns && ns[m]) return ns[m](o, ...args);
      } else if (Array.isArray(o)) {
        if (_jac.poly._list[m]) return _jac.poly._list[m](o, ...args);
      } else if (o instanceof Set) {
        if (_jac.poly._set[m]) return _jac.poly._set[m](o, ...args);
      } else if (o instanceof Map) {
        if (_jac.poly._map[m]) return _jac.poly._map[m](o, ...args);
      } else if (o instanceof Uint8Array) {
        if (_jac.bytes[m]) return _jac.bytes[m](o, ...args);
      } else if (
        o !== null && o !== undefined && typeof o === "object"
        && (Object.getPrototypeOf(o) === Object.prototype
            || Object.getPrototypeOf(o) === null)
      ) {
        // A plain object is a Python dict literal.
        if (_jac.poly._dict[m]) return _jac.poly._dict[m](o, ...args);
      }
      // 2. Otherwise forward to a same-named method the receiver carries
      //    itself: a user-defined class instance, a host/framework object
      //    (Headers, URLSearchParams, ...), a callable with attached methods,
      //    or a Set/Map/Array method not mirrored above. This matches the
      //    direct `obj.method(...)` that a typed call would have emitted.
      if (o !== null && o !== undefined && typeof o[m] === "function") {
        return o[m](...args);
      }
      // 3. Nothing applies: raise the Python-style error instead of leaking a
      //    method name or silently returning a wrong value.
      throw new _jac.exc.AttributeError(
        "'" + _jac.poly._typename(o) + "' object has no attribute '" + m + "'");
    },
    // Backward-compatible named shims. The compiler now emits `call`, but a
    // previously-built bundle may still reference a named helper; these route
    // it through the same dispatcher (rest params preserve the arg count).
    lower(s, ...r) { return _jac.poly.call(s, "lower", ...r); },
    upper(s, ...r) { return _jac.poly.call(s, "upper", ...r); },
    strip(s, ...r) { return _jac.poly.call(s, "strip", ...r); },
    lstrip(s, ...r) { return _jac.poly.call(s, "lstrip", ...r); },
    rstrip(s, ...r) { return _jac.poly.call(s, "rstrip", ...r); },
    append(a, ...r) { return _jac.poly.call(a, "append", ...r); },
    extend(a, ...r) { return _jac.poly.call(a, "extend", ...r); },
    pop(a, ...r) { return _jac.poly.call(a, "pop", ...r); },
    get(o, ...r) { return _jac.poly.call(o, "get", ...r); },
    contains(c, x) {
      // Python-equivalent membership for a value of unknown static type.
      // string -> substring; array (list/tuple/range) -> element;
      // Set/Map -> key/element; plain object (dict) -> own key.
      if (typeof c === "string") return c.includes(x);
      if (Array.isArray(c)) return c.includes(x);
      if (c instanceof Set || c instanceof Map) return c.has(x);
      if (c !== null && typeof c === "object") {
        return Object.prototype.hasOwnProperty.call(c, x);
      }
      return false;
    },
    getitem(c, i) {
      // Subscript read for a value of unknown static type. This is a faithful
      // superset of a raw `c[i]`: it only adds Python's negative indexing for
      // sequences (string/array) and otherwise preserves JS semantics exactly
      // (mapping/object access, out-of-range -> `undefined`, no new throws).
      if (typeof i === "number" && i < 0
          && (typeof c === "string" || Array.isArray(c))) {
        return c[c.length + i];
      }
      if (c instanceof Map) return c.get(i);
      return c[i];
    },
    setitem(c, i, v) {
      // Subscript assignment for a value of unknown/list static type. A
      // negative index writes the array element counted from the end (a raw
      // JS `c[-1] = v` would instead create a bogus "-1" property); every
      // other case behaves like a plain `c[i] = v`.
      if (typeof i === "number" && i < 0 && Array.isArray(c)) {
        c[c.length + i] = v;
        return v;
      }
      if (c instanceof Map) { c.set(i, v); return v; }
      c[i] = v;
      return v;
    },
    and_(a, bf) {
      // Python `a and b`: returns `a` when it is falsy, else evaluates and
      // returns `b`. `bf` is a thunk so the right operand keeps short-circuit
      // (lazy) evaluation, and `a` is evaluated exactly once by the caller.
      return _jac.builtin.bool(a) ? bf() : a;
    },
    or_(a, bf) {
      // Python `a or b`: returns `a` when it is truthy, else `b`.
      return _jac.builtin.bool(a) ? a : bf();
    }
  },

  list: {
    remove(arr, val) {
      const i = arr.indexOf(val);
      if (i === -1) throw new _jac.exc.ValueError("list.remove(x): x not in list");
      arr.splice(i, 1);
    },
    index(arr, val, start, end) {
      const s = start || 0;
      const e = end === undefined ? arr.length : end;
      for (let i = s; i < e; i++) {
        if (arr[i] === val) return i;
      }
      throw new _jac.exc.ValueError(val + " is not in list");
    },
    count(arr, val) {
      let c = 0;
      for (const item of arr) { if (item === val) c++; }
      return c;
    },
    sort(arr, key) {
      if (key) {
        arr.sort((a, b) => {
          const ka = key(a), kb = key(b);
          return ka < kb ? -1 : ka > kb ? 1 : 0;
        });
      } else {
        arr.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
      }
    },
    repeat(arr, n) {
      const result = [];
      for (let i = 0; i < n; i++) result.push(...arr);
      return result;
    },
    eq(a, b) { return JSON.stringify(a) === JSON.stringify(b); },
    lt(a, b) {
      for (let i = 0; i < Math.min(a.length, b.length); i++) {
        if (a[i] < b[i]) return true;
        if (a[i] > b[i]) return false;
      }
      return a.length < b.length;
    },
    gt(a, b) { return _jac.list.lt(b, a); },
    le(a, b) { return _jac.list.eq(a, b) || _jac.list.lt(a, b); },
    ge(a, b) { return _jac.list.eq(a, b) || _jac.list.gt(a, b); },
    imul(arr, n) {
      const orig = [...arr];
      arr.length = 0;
      for (let i = 0; i < n; i++) arr.push(...orig);
      return arr;
    }
  },

  dict: {
    pop(d, key, default_) {
      if (key in d) { const v = d[key]; delete d[key]; return v; }
      if (default_ !== undefined) return default_;
      throw new _jac.exc.KeyError("KeyError: " + key);
    },
    popitem(d) {
      const keys = Object.keys(d);
      if (keys.length === 0) throw new _jac.exc.KeyError("dictionary is empty");
      const key = keys[keys.length - 1];
      const val = d[key];
      delete d[key];
      return [key, val];
    },
    setdefault(d, key, default_) {
      if (!(key in d)) d[key] = default_ === undefined ? null : default_;
      return d[key];
    },
    clear(d) {
      for (const key of Object.keys(d)) delete d[key];
    },
    fromkeys(keys, value) {
      const d = {};
      const v = value === undefined ? null : value;
      for (const k of keys) d[k] = v;
      return d;
    },
    eq(a, b) {
      const ka = Object.keys(a), kb = Object.keys(b);
      if (ka.length !== kb.length) return false;
      for (const k of ka) {
        if (!(k in b)) return false;
        const va = a[k], vb = b[k];
        if (va !== vb) {
          if (typeof va === "object" && typeof vb === "object" && va !== null && vb !== null) {
            if (JSON.stringify(va) !== JSON.stringify(vb)) return false;
          } else return false;
        }
      }
      return true;
    }
  },

  set: {
    remove(s, val) {
      if (!s.has(val)) throw new _jac.exc.KeyError("KeyError: " + val);
      s.delete(val);
    },
    pop(s) {
      if (s.size === 0) throw new _jac.exc.KeyError("pop from an empty set");
      const val = s.values().next().value;
      s.delete(val);
      return val;
    },
    update(s, other) { for (const v of other) s.add(v); },
    intersection_update(s, other) {
      const otherSet = other instanceof Set ? other : new Set(other);
      for (const v of s) { if (!otherSet.has(v)) s.delete(v); }
    },
    difference_update(s, other) {
      for (const v of other) s.delete(v);
    },
    symmetric_difference_update(s, other) {
      for (const v of other) { if (s.has(v)) s.delete(v); else s.add(v); }
    },
    union(a, b) {
      const r = new Set(a);
      for (const v of b) r.add(v);
      return r;
    },
    intersection(a, b) {
      const bs = b instanceof Set ? b : new Set(b);
      const r = new Set();
      for (const v of a) { if (bs.has(v)) r.add(v); }
      return r;
    },
    difference(a, b) {
      const bs = b instanceof Set ? b : new Set(b);
      const r = new Set();
      for (const v of a) { if (!bs.has(v)) r.add(v); }
      return r;
    },
    symmetricDifference(a, b) {
      const r = new Set(a);
      for (const v of b) { if (r.has(v)) r.delete(v); else r.add(v); }
      return r;
    },
    isSubsetOf(a, b) {
      if (a.size > b.size) return false;
      for (const v of a) { if (!b.has(v)) return false; }
      return true;
    },
    isSupersetOf(a, b) { return _jac.set.isSubsetOf(b, a); },
    isDisjointFrom(a, b) {
      for (const v of a) { if (b.has(v)) return false; }
      return true;
    },
    is_proper_subset(a, b) {
      if (a.size >= b.size) return false;
      for (const v of a) { if (!b.has(v)) return false; }
      return true;
    },
    is_proper_superset(a, b) { return _jac.set.is_proper_subset(b, a); },
    eq(a, b) {
      if (a.size !== b.size) return false;
      for (const v of a) { if (!b.has(v)) return false; }
      return true;
    }
  },

  bytes: {
    hex(b) {
      return Array.from(b).map(x => x.toString(16).padStart(2, "0")).join("");
    },
    fromhex(s) {
      const arr = [];
      const clean = s.replace(/\s/g, "");
      for (let i = 0; i < clean.length; i += 2) arr.push(parseInt(clean.substr(i, 2), 16));
      return new Uint8Array(arr);
    },
    _indexOf(b, sub, start, end) {
      const s = start || 0;
      const e = end === undefined ? b.length : end;
      const sl = sub.length;
      if (sl === 0) return s;
      for (let i = s; i <= e - sl; i++) {
        let m = true;
        for (let j = 0; j < sl; j++) { if (b[i + j] !== sub[j]) { m = false; break; } }
        if (m) return i;
      }
      return -1;
    },
    _lastIndexOf(b, sub, start, end) {
      const s = start || 0;
      const e = end === undefined ? b.length : end;
      const sl = sub.length;
      if (sl === 0) return e;
      for (let i = e - sl; i >= s; i--) {
        let m = true;
        for (let j = 0; j < sl; j++) { if (b[i + j] !== sub[j]) { m = false; break; } }
        if (m) return i;
      }
      return -1;
    },
    count(b, sub) {
      let c = 0, p = 0;
      while (p <= b.length - sub.length) {
        const idx = _jac.bytes._indexOf(b, sub, p);
        if (idx === -1) break;
        c++; p = idx + sub.length;
      }
      return c;
    },
    find(b, sub, start, end) { return _jac.bytes._indexOf(b, sub, start, end); },
    rfind(b, sub, start, end) { return _jac.bytes._lastIndexOf(b, sub, start, end); },
    index(b, sub, start, end) {
      const idx = _jac.bytes._indexOf(b, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    rindex(b, sub, start, end) {
      const idx = _jac.bytes._lastIndexOf(b, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    startswith(b, prefix, start, end) {
      const s = start || 0;
      if (prefix.length > b.length - s) return false;
      for (let i = 0; i < prefix.length; i++) { if (b[s + i] !== prefix[i]) return false; }
      return true;
    },
    endswith(b, suffix, start, end) {
      const e = end === undefined ? b.length : end;
      if (suffix.length > e) return false;
      const off = e - suffix.length;
      for (let i = 0; i < suffix.length; i++) { if (b[off + i] !== suffix[i]) return false; }
      return true;
    },
    replace(b, old_, new_, count) {
      const r = [];
      let pos = 0, n = 0;
      const max = count === undefined ? Infinity : count;
      while (pos <= b.length) {
        if (n < max) {
          const idx = _jac.bytes._indexOf(b, old_, pos);
          if (idx !== -1) {
            for (let i = pos; i < idx; i++) r.push(b[i]);
            for (let i = 0; i < new_.length; i++) r.push(new_[i]);
            pos = idx + old_.length; n++;
            continue;
          }
        }
        for (let i = pos; i < b.length; i++) r.push(b[i]);
        break;
      }
      return new Uint8Array(r);
    },
    _isWS(c) { return c === 32 || c === 9 || c === 10 || c === 13 || c === 11 || c === 12; },
    strip(b, chars) {
      let s = 0, e = b.length;
      if (chars) { const cs = new Set(chars); while (s < e && cs.has(b[s])) s++; while (e > s && cs.has(b[e-1])) e--; }
      else { while (s < e && _jac.bytes._isWS(b[s])) s++; while (e > s && _jac.bytes._isWS(b[e-1])) e--; }
      return b.slice(s, e);
    },
    lstrip(b, chars) {
      let s = 0;
      if (chars) { const cs = new Set(chars); while (s < b.length && cs.has(b[s])) s++; }
      else { while (s < b.length && _jac.bytes._isWS(b[s])) s++; }
      return b.slice(s);
    },
    rstrip(b, chars) {
      let e = b.length;
      if (chars) { const cs = new Set(chars); while (e > 0 && cs.has(b[e-1])) e--; }
      else { while (e > 0 && _jac.bytes._isWS(b[e-1])) e--; }
      return b.slice(0, e);
    },
    removeprefix(b, prefix) {
      if (_jac.bytes.startswith(b, prefix)) return b.slice(prefix.length);
      return b.slice();
    },
    removesuffix(b, suffix) {
      if (suffix.length > 0 && _jac.bytes.endswith(b, suffix)) return b.slice(0, b.length - suffix.length);
      return b.slice();
    },
    split(b, sep, maxsplit) {
      const parts = [];
      let pos = 0, n = 0;
      const max = maxsplit === undefined ? Infinity : maxsplit;
      while (pos <= b.length) {
        if (n >= max) { parts.push(b.slice(pos)); return parts; }
        const idx = _jac.bytes._indexOf(b, sep, pos);
        if (idx === -1) { parts.push(b.slice(pos)); return parts; }
        parts.push(b.slice(pos, idx));
        pos = idx + sep.length; n++;
      }
      if (pos <= b.length) parts.push(b.slice(pos));
      return parts;
    },
    rsplit(b, sep, maxsplit) {
      if (maxsplit === undefined) return _jac.bytes.split(b, sep);
      const parts = [];
      let end = b.length, n = 0;
      while (end >= 0 && n < maxsplit) {
        const idx = _jac.bytes._lastIndexOf(b, sep, 0, end);
        if (idx === -1) break;
        parts.unshift(b.slice(idx + sep.length, end));
        end = idx; n++;
      }
      parts.unshift(b.slice(0, end));
      return parts;
    },
    splitlines(b, keepends) {
      const result = [];
      let start = 0;
      for (let i = 0; i < b.length; i++) {
        if (b[i] === 10 || b[i] === 13) {
          let eol = i + 1;
          if (b[i] === 13 && i + 1 < b.length && b[i + 1] === 10) eol++;
          result.push(keepends ? b.slice(start, eol) : b.slice(start, i));
          start = eol;
          if (eol > i + 1) i++;
        }
      }
      if (start < b.length) result.push(b.slice(start));
      return result;
    },
    join(sep, parts) {
      if (parts.length === 0) return new Uint8Array(0);
      const r = [];
      for (let i = 0; i < parts.length; i++) {
        if (i > 0) for (const x of sep) r.push(x);
        for (const x of parts[i]) r.push(x);
      }
      return new Uint8Array(r);
    },
    partition(b, sep) {
      const idx = _jac.bytes._indexOf(b, sep);
      if (idx === -1) return [b.slice(), new Uint8Array(0), new Uint8Array(0)];
      return [b.slice(0, idx), sep.slice(), b.slice(idx + sep.length)];
    },
    rpartition(b, sep) {
      const idx = _jac.bytes._lastIndexOf(b, sep);
      if (idx === -1) return [new Uint8Array(0), new Uint8Array(0), b.slice()];
      return [b.slice(0, idx), sep.slice(), b.slice(idx + sep.length)];
    },
    _isUp(c) { return c >= 65 && c <= 90; },
    _isLo(c) { return c >= 97 && c <= 122; },
    _isAl(c) { return (c >= 65 && c <= 90) || (c >= 97 && c <= 122); },
    _isDig(c) { return c >= 48 && c <= 57; },
    capitalize(b) {
      if (b.length === 0) return new Uint8Array(0);
      const r = new Uint8Array(b.length);
      r[0] = _jac.bytes._isLo(b[0]) ? b[0] - 32 : b[0];
      for (let i = 1; i < b.length; i++) r[i] = _jac.bytes._isUp(b[i]) ? b[i] + 32 : b[i];
      return r;
    },
    lower(b) {
      const r = new Uint8Array(b.length);
      for (let i = 0; i < b.length; i++) r[i] = _jac.bytes._isUp(b[i]) ? b[i] + 32 : b[i];
      return r;
    },
    upper(b) {
      const r = new Uint8Array(b.length);
      for (let i = 0; i < b.length; i++) r[i] = _jac.bytes._isLo(b[i]) ? b[i] - 32 : b[i];
      return r;
    },
    title(b) {
      const r = new Uint8Array(b.length);
      let prev = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isAl(b[i])) {
          r[i] = prev ? (_jac.bytes._isUp(b[i]) ? b[i] + 32 : b[i]) : (_jac.bytes._isLo(b[i]) ? b[i] - 32 : b[i]);
          prev = true;
        } else { r[i] = b[i]; prev = false; }
      }
      return r;
    },
    swapcase(b) {
      const r = new Uint8Array(b.length);
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isUp(b[i])) r[i] = b[i] + 32;
        else if (_jac.bytes._isLo(b[i])) r[i] = b[i] - 32;
        else r[i] = b[i];
      }
      return r;
    },
    center(b, width, fb) {
      const f = fb || 32;
      if (b.length >= width) return b.slice();
      const total = width - b.length;
      const left = Math.floor(total / 2);
      const r = new Uint8Array(width);
      r.fill(f, 0, left); r.set(b, left); r.fill(f, left + b.length);
      return r;
    },
    ljust(b, width, fb) {
      const f = fb || 32;
      if (b.length >= width) return b.slice();
      const r = new Uint8Array(width);
      r.set(b); r.fill(f, b.length);
      return r;
    },
    rjust(b, width, fb) {
      const f = fb || 32;
      if (b.length >= width) return b.slice();
      const r = new Uint8Array(width);
      const off = width - b.length;
      r.fill(f, 0, off); r.set(b, off);
      return r;
    },
    zfill(b, width) {
      if (b.length >= width) return b.slice();
      const r = new Uint8Array(width);
      let off = 0;
      if (b.length > 0 && (b[0] === 43 || b[0] === 45)) { r[0] = b[0]; off = 1; }
      const pad = width - b.length;
      r.fill(48, off, off + pad);
      for (let i = off; i < b.length; i++) r[pad + i] = b[i];
      return r;
    },
    expandtabs(b, tabsize) {
      const ts = tabsize === undefined ? 8 : tabsize;
      const r = [];
      let col = 0;
      for (let i = 0; i < b.length; i++) {
        if (b[i] === 9) { const sp = ts - (col % ts); for (let j = 0; j < sp; j++) r.push(32); col += sp; }
        else if (b[i] === 10 || b[i] === 13) { r.push(b[i]); col = 0; }
        else { r.push(b[i]); col++; }
      }
      return new Uint8Array(r);
    },
    translate(b, table, del_) {
      const r = [];
      const ds = del_ ? new Set(del_) : null;
      for (let i = 0; i < b.length; i++) {
        if (ds && ds.has(b[i])) continue;
        r.push(table && table[b[i]] !== undefined ? table[b[i]] : b[i]);
      }
      return new Uint8Array(r);
    },
    maketrans(from_, to_) {
      const t = new Uint8Array(256);
      for (let i = 0; i < 256; i++) t[i] = i;
      for (let i = 0; i < from_.length; i++) t[from_[i]] = to_[i];
      return t;
    },
    isalnum(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isAl(b[i]) && !_jac.bytes._isDig(b[i])) return false;
      return true;
    },
    isalpha(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isAl(b[i])) return false;
      return true;
    },
    isascii(b) {
      for (let i = 0; i < b.length; i++) if (b[i] > 127) return false;
      return true;
    },
    isdigit(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isDig(b[i])) return false;
      return true;
    },
    islower(b) {
      let has = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isUp(b[i])) return false;
        if (_jac.bytes._isLo(b[i])) has = true;
      }
      return has;
    },
    isupper(b) {
      let has = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isLo(b[i])) return false;
        if (_jac.bytes._isUp(b[i])) has = true;
      }
      return has;
    },
    isspace(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isWS(b[i])) return false;
      return true;
    },
    istitle(b) {
      let prev = false, has = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isUp(b[i])) { if (prev) return false; prev = true; has = true; }
        else if (_jac.bytes._isLo(b[i])) { if (!prev) return false; prev = true; has = true; }
        else prev = false;
      }
      return has;
    },
    add(a, b) {
      const r = new Uint8Array(a.length + b.length);
      r.set(a); r.set(b, a.length);
      return r;
    },
    mul(b, n) {
      const r = new Uint8Array(b.length * n);
      for (let i = 0; i < n; i++) r.set(b, i * b.length);
      return r;
    },
    mod(b, args) {
      const s = new TextDecoder().decode(b);
      return new TextEncoder().encode(_jac.str.mod(s, args));
    },
    eq(a, b) {
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
      return true;
    },
    lt(a, b) {
      for (let i = 0; i < Math.min(a.length, b.length); i++) {
        if (a[i] < b[i]) return true;
        if (a[i] > b[i]) return false;
      }
      return a.length < b.length;
    },
    gt(a, b) { return _jac.bytes.lt(b, a); },
    le(a, b) { return _jac.bytes.eq(a, b) || _jac.bytes.lt(a, b); },
    ge(a, b) { return _jac.bytes.eq(a, b) || _jac.bytes.gt(a, b); },
    contains(b, sub) { return _jac.bytes._indexOf(b, sub) !== -1; }
  },

  tuple: {
    count(arr, val) { return _jac.list.count(arr, val); },
    index(arr, val, start, end) { return _jac.list.index(arr, val, start, end); },
    repeat(arr, n) { return _jac.list.repeat(arr, n); },
    eq(a, b) { return _jac.list.eq(a, b); },
    lt(a, b) { return _jac.list.lt(a, b); },
    gt(a, b) { return _jac.list.gt(a, b); },
    le(a, b) { return _jac.list.le(a, b); },
    ge(a, b) { return _jac.list.ge(a, b); }
  },

  range: {
    count(r, val) {
      if (typeof r[Symbol.iterator] === "function") {
        let c = 0;
        for (const v of r) { if (v === val) c++; }
        return c;
      }
      return 0;
    },
    index(r, val) {
      let i = 0;
      for (const v of r) { if (v === val) return i; i++; }
      throw new _jac.exc.ValueError(val + " is not in range");
    },
    eq(a, b) {
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) { if (a[i] !== b[i]) return false; }
      return true;
    },
    contains(r, val) {
      for (const v of r) { if (v === val) return true; }
      return false;
    }
  },

  // Builtin types as first-class values -- `map(int, xs)`, `key=str`,
  // `f = int`, `[str, int]`.  In Python `int` is a single object playing two
  // roles, so it lowers to a single object here too: a callable whose body is
  // generated from the same emitters the direct-call path uses (so
  // `f = int; f(x)` can never drift from `int(x)`), carrying the
  // `__jac_type__` tag that isinstance/issubclass compare against.
  types: (() => {
    const _t = (tag, fn) => Object.assign(fn, {
      __jac_type__: tag,
      toString: () => "<class '" + tag + "'>"
    });
    return {
    any: _t("any", (...a) => (a[0].some(Boolean))),
    bool: _t("bool", (...a) => a.length === 0 ? (false) : a.length === 1 ? (_jac.builtin.bool(a[0])) : (_jac.builtin.bool(a[0], a[1]))),
    bytes: _t("bytes", (...a) => a.length === 0 ? (new Uint8Array()) : (new Uint8Array(a[0]))),
    dict: _t("dict", (...a) => a.length === 0 ? ({}) : (Object.fromEntries(a[0]))),
    float: _t("float", (...a) => a.length === 0 ? (0.0) : (parseFloat(a[0]))),
    int: _t("int", (...a) => a.length === 0 ? (0) : a.length === 1 ? (Math.trunc(Number(a[0]))) : (parseInt(a[0], a[1]))),
    list: _t("list", (...a) => a.length === 0 ? ([]) : (Array.from(a[0]))),
    set: _t("set", (...a) => a.length === 0 ? (new Set()) : (new Set(a[0]))),
    str: _t("str", (...a) => a.length === 0 ? ("") : (String(a[0]))),
    tuple: _t("tuple", (...a) => a.length === 0 ? (Object.freeze([])) : (Object.freeze(Array.from(a[0])))),
    type: _t("type", (...a) => (typeof a[0]))
    };
  })(),

  builtin: {
    round(n, ndigits) {
      if (ndigits === undefined) return Math.round(n);
      const f = Math.pow(10, ndigits);
      return Math.round(n * f) / f;
    },
    sum(iterable, start) {
      let total = start || 0;
      for (const v of iterable) total += v;
      return total;
    },
    sorted(iterable, key, reverse) {
      const arr = [...iterable];
      if (key) {
        arr.sort((a, b) => {
          const ka = key(a), kb = key(b);
          return ka < kb ? -1 : ka > kb ? 1 : 0;
        });
      } else {
        arr.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
      }
      if (reverse) arr.reverse();
      return arr;
    },
    enumerate(iterable, start) {
      const s = start || 0;
      return [...iterable].map((v, i) => [s + i, v]);
    },
    zip(...iterables) {
      const arrays = iterables.map(it => [...it]);
      const len = Math.min(...arrays.map(a => a.length));
      const result = [];
      for (let i = 0; i < len; i++) {
        result.push(arrays.map(a => a[i]));
      }
      return result;
    },
    map(fn, ...iterables) {
      // Python hands the callback exactly one element per iterable, while JS's
      // `Array.prototype.map` would also hand it (index, array) -- which a
      // two-arity callable like `int(x, base)` reads as a radix.
      if (iterables.length === 1) return [...iterables[0]].map((v) => fn(v));
      const arrays = iterables.map(it => [...it]);
      const len = Math.min(...arrays.map(a => a.length));
      const result = [];
      for (let i = 0; i < len; i++) {
        result.push(fn(...arrays.map(a => a[i])));
      }
      return result;
    },
    filter(fn, iterable) {
      return [...iterable].filter((v) => fn ? fn(v) : v);
    },
    // The Python type of a builtin-type value, as a tag string.  A builtin type
    // reaches classinfo position in either of the two spellings the compiler
    // emits: the runtime type object (`_jac.types.int`, which carries the tag)
    // or the bare tag itself (an erased annotation, or `_typename` output).
    _typeTag(t) {
      return (t !== null && t !== undefined && t.__jac_type__) || t;
    },
    // Python subclass relation over builtin-type tags. `object` is the
    // universal base and `bool` is a subclass of `int`; `tuple` and `frozenset`
    // share JS representations with `list`/`set`, so fold those aliases to
    // their runtime tag first. One source of truth so isinstance and issubclass
    // can never disagree.
    _tagSubclass(subTag, superTag) {
      const fold = (t) => {
        const tag = _jac.builtin._typeTag(t);
        return tag === "tuple" ? "list" : tag === "frozenset" ? "set" : tag;
      };
      const sub = fold(subTag), sup = fold(superTag);
      if (sup === "object") return true;
      if (sub === sup) return true;
      if (sup === "int" && sub === "bool") return true;
      return false;
    },
    isinstance(o, classinfo) {
      // isinstance(x, (A, B, ...)) -- the tuple of types lowers to a JS array;
      // match if `o` is an instance of any member.
      if (Array.isArray(classinfo)) {
        for (const c of classinfo) {
          if (_jac.builtin.isinstance(o, c)) return true;
        }
        return false;
      }
      // Builtin type: compare the value's runtime type against its tag via the
      // shared subclass relation.  Checked before the constructor branch --
      // a type object is a callable too, and `o instanceof int` is meaningless.
      const tag = _jac.builtin._typeTag(classinfo);
      if (typeof tag === "string") {
        return _jac.builtin._tagSubclass(_jac.poly._typename(o), tag);
      }
      // User archetype / JS constructor.
      if (typeof classinfo === "function") return o instanceof classinfo;
      return false;
    },
    issubclass(cls, classinfo) {
      if (Array.isArray(classinfo)) {
        for (const c of classinfo) {
          if (_jac.builtin.issubclass(cls, c)) return true;
        }
        return false;
      }
      // When either side names a builtin type, compare by the shared subclass
      // relation (covers `object`, `bool` ⊂ `int`, and identity).
      const subTag = _jac.builtin._typeTag(cls);
      const supTag = _jac.builtin._typeTag(classinfo);
      if (typeof subTag === "string" || typeof supTag === "string") {
        return _jac.builtin._tagSubclass(subTag, supTag);
      }
      if (cls === classinfo) return true;
      let proto = cls;
      while (proto) {
        if (proto === classinfo) return true;
        proto = Object.getPrototypeOf(proto);
      }
      return false;
    },
    id(o) {
      if (o === null || o === undefined) return 0;
      if (typeof o === "number") return o;
      return typeof o === "string" ? _jac.builtin._strHash(o) : 0;
    },
    _strHash(s) {
      let h = 0;
      for (let i = 0; i < s.length; i++) {
        h = ((h << 5) - h + s.charCodeAt(i)) | 0;
      }
      return h;
    },
    jid(obj) {
      if (obj === null || obj === undefined) {
        throw new _jac.exc.TypeError(
          "jid() called on " + String(obj)
          + " -- the server may have returned an error instead of a node."
          + " Check that your endpoint returned successfully before using jid()."
        );
      }
      if (obj._jac_id === undefined) {
        throw new _jac.exc.TypeError(
          "jid() expected a node or edge with graph identity, but received "
          + (typeof obj === "object" ? JSON.stringify(Object.keys(obj)) : typeof obj)
          + ". Only node and edge archetypes have a jid."
        );
      }
      return obj._jac_id;
    },
    // unsafe_html(x) returns a sentinel object that the JSX flattener
    // recognises and renders as raw HTML via dangerouslySetInnerHTML.
    // Named "unsafe" so the security implication is visible at the use site.
    unsafe_html(html) {
      return { __jacUnsafeHtml: String(html == null ? "" : html) };
    },
    hash(obj) { return _jac.builtin.id(obj); },
    repr(obj) { return JSON.stringify(obj); },
    pow(base, exp, mod) {
      let result = Math.pow(base, exp);
      if (mod !== undefined) result = ((result % mod) + mod) % mod;
      return result;
    },
    next(iter, default_) {
      const result = iter.next();
      if (result.done) {
        if (default_ !== undefined) return default_;
        throw new _jac.exc.StopIteration("StopIteration");
      }
      return result.value;
    },
    vars(o) {
      if (o === undefined) return {};
      const result = {};
      for (const [k, v] of Object.entries(o)) {
        if (typeof v !== "function") result[k] = v;
      }
      return result;
    },
    dir(o) {
      if (o === undefined) return [];
      return Object.getOwnPropertyNames(o).sort();
    },
    open() { throw new _jac.exc.OSError("open() is not supported in client-side JavaScript"); },
    format(value, format_spec) {
      if (!format_spec) return String(value);
      return String(value);
    },
    ascii(obj) {
      if (typeof obj === "string") {
        let r = "'";
        for (const c of obj) {
          const code = c.charCodeAt(0);
          if (c === "\\") r += "\\\\";
          else if (c === "'") r += "\\'";
          else if (code >= 0x20 && code <= 0x7e) r += c;
          else if (code < 0x100) r += "\\x" + code.toString(16).padStart(2, "0");
          else r += "\\u" + code.toString(16).padStart(4, "0");
        }
        return r + "'";
      }
      return String(obj);
    },
    complex(re, im) { return {re: re || 0, im: im || 0}; },
    bool(x) {
      if (x === null || x === undefined || x === false || x === 0 || x === "" || Number.isNaN(x)) return false;
      if (Array.isArray(x)) return x.length > 0;
      if (x instanceof Set || x instanceof Map) return x.size > 0;
      if (typeof x === "object") return Object.keys(x).length > 0;
      return true;
    },
    range(...args) {
      let start, stop, step;
      if (args.length === 1) { start = 0; stop = args[0]; step = 1; }
      else if (args.length === 2) { start = args[0]; stop = args[1]; step = 1; }
      else { start = args[0]; stop = args[1]; step = args[2]; }
      if (step === 0) throw new _jac.exc.ValueError("range() arg 3 must not be zero");
      const result = [];
      if (step > 0) { for (let i = start; i < stop; i += step) result.push(i); }
      else { for (let i = start; i > stop; i += step) result.push(i); }
      return result;
    },
    slice(...args) {
      if (args.length === 1) return { start: null, stop: args[0], step: null };
      return { start: args[0] !== undefined ? args[0] : null, stop: args[1] !== undefined ? args[1] : null, step: args[2] !== undefined ? args[2] : null };
    },
    format(value, format_spec) {
      if (!format_spec || format_spec === "") return String(value);
      const m = format_spec.match(/^([<>^]?)(\d+)?(?:\.(\d+))?([dfseboxXn%]?)$/);
      if (!m) return String(value);
      const [, align, widthStr, precStr, ftype] = m;
      let s;
      const prec = precStr !== undefined ? parseInt(precStr) : undefined;
      if (ftype === "f" || ftype === "") {
        s = prec !== undefined ? Number(value).toFixed(prec) : String(value);
      } else if (ftype === "d") {
        s = String(Math.floor(Number(value)));
      } else if (ftype === "b") {
        s = Number(value).toString(2);
      } else if (ftype === "o") {
        s = Number(value).toString(8);
      } else if (ftype === "x") {
        s = Number(value).toString(16);
      } else if (ftype === "X") {
        s = Number(value).toString(16).toUpperCase();
      } else if (ftype === "e") {
        s = prec !== undefined ? Number(value).toExponential(prec) : Number(value).toExponential();
      } else if (ftype === "%") {
        s = (prec !== undefined ? (Number(value) * 100).toFixed(prec) : (Number(value) * 100).toFixed(6)) + "%";
      } else if (ftype === "s" || ftype === "n") {
        s = String(value);
      } else {
        s = String(value);
      }
      if (widthStr) {
        const width = parseInt(widthStr);
        if (s.length < width) {
          const pad = " ".repeat(width - s.length);
          if (align === "<") s = s + pad;
          else if (align === "^") {
            const left = Math.floor((width - s.length) / 2);
            s = " ".repeat(left) + s + " ".repeat(width - s.length - left);
          }
          else s = pad + s;
        }
      }
      return s;
    }
  },

  exc: (() => {
    class BaseException extends Error { constructor(m) { super(m); this.name = 'BaseException'; } }
    class Exception extends BaseException { constructor(m) { super(m); this.name = 'Exception'; } }
    class ArithmeticError extends Exception { constructor(m) { super(m); this.name = 'ArithmeticError'; } }
    class ZeroDivisionError extends ArithmeticError { constructor(m) { super(m); this.name = 'ZeroDivisionError'; } }
    class OverflowError extends ArithmeticError { constructor(m) { super(m); this.name = 'OverflowError'; } }
    class FloatingPointError extends ArithmeticError { constructor(m) { super(m); this.name = 'FloatingPointError'; } }
    class LookupError extends Exception { constructor(m) { super(m); this.name = 'LookupError'; } }
    class IndexError extends LookupError { constructor(m) { super(m); this.name = 'IndexError'; } }
    class KeyError extends LookupError { constructor(m) { super(m); this.name = 'KeyError'; } }
    class ValueError extends Exception { constructor(m) { super(m); this.name = 'ValueError'; } }
    class TypeError_ extends Exception { constructor(m) { super(m); this.name = 'TypeError'; } }
    class AttributeError extends Exception { constructor(m) { super(m); this.name = 'AttributeError'; } }
    class RuntimeError extends Exception { constructor(m) { super(m); this.name = 'RuntimeError'; } }
    class NotImplementedError extends RuntimeError { constructor(m) { super(m); this.name = 'NotImplementedError'; } }
    class RecursionError extends RuntimeError { constructor(m) { super(m); this.name = 'RecursionError'; } }
    class OSError extends Exception { constructor(m) { super(m); this.name = 'OSError'; } }
    class FileNotFoundError extends OSError { constructor(m) { super(m); this.name = 'FileNotFoundError'; } }
    class FileExistsError extends OSError { constructor(m) { super(m); this.name = 'FileExistsError'; } }
    class PermissionError extends OSError { constructor(m) { super(m); this.name = 'PermissionError'; } }
    class TimeoutError extends OSError { constructor(m) { super(m); this.name = 'TimeoutError'; } }
    class IsADirectoryError extends OSError { constructor(m) { super(m); this.name = 'IsADirectoryError'; } }
    class NotADirectoryError extends OSError { constructor(m) { super(m); this.name = 'NotADirectoryError'; } }
    class AssertionError extends Exception { constructor(m) { super(m); this.name = 'AssertionError'; } }
    class ImportError extends Exception { constructor(m) { super(m); this.name = 'ImportError'; } }
    class ModuleNotFoundError extends ImportError { constructor(m) { super(m); this.name = 'ModuleNotFoundError'; } }
    class NameError extends Exception { constructor(m) { super(m); this.name = 'NameError'; } }
    class UnboundLocalError extends NameError { constructor(m) { super(m); this.name = 'UnboundLocalError'; } }
    class StopIteration extends Exception { constructor(m) { super(m); this.name = 'StopIteration'; } }
    class StopAsyncIteration extends Exception { constructor(m) { super(m); this.name = 'StopAsyncIteration'; } }
    class EOFError extends Exception { constructor(m) { super(m); this.name = 'EOFError'; } }
    class MemoryError extends Exception { constructor(m) { super(m); this.name = 'MemoryError'; } }
    class ReferenceError_ extends Exception { constructor(m) { super(m); this.name = 'ReferenceError'; } }
    class KeyboardInterrupt extends BaseException { constructor(m) { super(m); this.name = 'KeyboardInterrupt'; } }
    class SystemExit extends BaseException { constructor(m) { super(m); this.name = 'SystemExit'; } }
    class GeneratorExit extends BaseException { constructor(m) { super(m); this.name = 'GeneratorExit'; } }
    const _all = { BaseException, Exception, ArithmeticError, ZeroDivisionError, OverflowError, FloatingPointError, LookupError, IndexError, KeyError, ValueError, TypeError: TypeError_, AttributeError, RuntimeError, NotImplementedError, RecursionError, OSError, FileNotFoundError, FileExistsError, PermissionError, TimeoutError, IsADirectoryError, NotADirectoryError, AssertionError, ImportError, ModuleNotFoundError, NameError, UnboundLocalError, StopIteration, StopAsyncIteration, EOFError, MemoryError, ReferenceError: ReferenceError_, KeyboardInterrupt, SystemExit, GeneratorExit };
    function matches(e, name) {
      if (name === 'BaseException') return true;
      if (name === 'Exception') return (e instanceof _all.Exception) || !(e instanceof _all.BaseException);
      const cls = _all[name];
      return cls ? (e instanceof cls) : false;
    }
    return Object.assign(_all, { matches });
  })()
};
function copy_text(text) {
  try {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
      return;
    }
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
  try {
    let ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
}
function upsert_meta(attr, key, content) {
  try {
    let selector = `meta[${attr}='${key}`;
    let el = document.querySelector(selector);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
}
function set_social_meta(title, description, url, image) {
  upsert_meta("property", "og:type", "article");
  upsert_meta("property", "og:site_name", "Jaseci Blogs");
  upsert_meta("property", "og:title", title);
  upsert_meta("property", "og:description", description);
  upsert_meta("property", "og:url", url);
  upsert_meta("name", "description", description);
  upsert_meta("name", "twitter:card", (image ? "summary_large_image" : "summary"));
  upsert_meta("name", "twitter:title", title);
  upsert_meta("name", "twitter:description", description);
  if (image) {
    upsert_meta("property", "og:image", image);
    upsert_meta("name", "twitter:image", image);
  }
}
function install_load_helper() {
  if (window.__loadMermaid) {
    return;
  }
  let s = document.createElement("script");
  s.textContent = "window.__loadScript=function(src){return new Promise(function(res,rej){var f=document.querySelector('script[data-ls=\"'+src+'\"]');if(f){res();return;}var el=document.createElement('script');el.src=src;el.setAttribute('data-ls',src);el.onload=function(){res();};el.onerror=function(){rej(new Error('failed to load '+src));};document.head.appendChild(el);});};window.__loadCss=function(href){return new Promise(function(res){if(document.querySelector('link[data-lc=\"'+href+'\"]')){res();return;}var l=document.createElement('link');l.rel='stylesheet';l.href=href;l.setAttribute('data-lc',href);l.onload=function(){res();};l.onerror=function(){res();};document.head.appendChild(l);});};window.__loadMermaid=function(){if(window.mermaid){return Promise.resolve(window.mermaid);}return import('https://cdn.jsdelivr.net/npm/mermaid@10/dist/mermaid.esm.min.mjs').then(function(m){window.mermaid=m.default;return m.default;});};";
  document.head.appendChild(s);
}
async function ensure_codemirror() {
  install_load_helper();
  if (!window.CodeMirror) {
    await window.__loadCss("https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.65.16/codemirror.min.css");
    await window.__loadCss("https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.65.16/theme/material-darker.min.css");
    await window.__loadScript("https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.65.16/codemirror.min.js");
  }
  define_jac_mode();
}
function define_jac_mode() {
  try {
    if ((window.CodeMirror && window.CodeMirror.__jacDefined)) {
      return;
    }
    let b64 = "KGZ1bmN0aW9uKCl7aWYoIXdpbmRvdy5Db2RlTWlycm9yfHxDb2RlTWlycm9yLl9famFjRGVmaW5lZCl7cmV0dXJuO312YXIgS1c9e307Im5vZGUgZWRnZSB3YWxrZXIgb2JqIGNsYXNzIGVudW0gaW1wbCBzZW0gaGFzIGNhbiBkZWYgd2l0aCBlbnRyeSBleGl0IHZpc2l0IHNwYXduIHJlcG9ydCBkaXNlbmdhZ2UgaWdub3JlIGhlcmUgdmlzaXRvciByb290IHNlbGYgc3VwZXIgaW5pdCBwb3N0aW5pdCBpbXBvcnQgaW5jbHVkZSBmcm9tIGFzIGdsb2IgbGV0IGlmIGVsaWYgZWxzZSBmb3Igd2hpbGUgcmV0dXJuIGluIHRvIGJ5IHRlc3QgY2hlY2sgYXNzZXJ0IHRyeSBleGNlcHQgZmluYWxseSByYWlzZSBkZWwgYW5kIG9yIG5vdCBpcyBhc3luYyBhd2FpdCBsYW1iZGEgeWllbGQgbWF0Y2ggY2FzZSBwcmludCBjbCBzdiIuc3BsaXQoIiAiKS5mb3JFYWNoKGZ1bmN0aW9uKGspe0tXW2tdPTE7fSk7dmFyIEFUT009eyJUcnVlIjoxLCJGYWxzZSI6MSwiTm9uZSI6MX07Q29kZU1pcnJvci5kZWZpbmVNb2RlKCJqYWMiLGZ1bmN0aW9uKCl7cmV0dXJue2xpbmVDb21tZW50OiIjIix0b2tlbjpmdW5jdGlvbihzdHJlYW0pe2lmKHN0cmVhbS5lYXRTcGFjZSgpKXtyZXR1cm4gbnVsbDt9dmFyIGNoPXN0cmVhbS5wZWVrKCk7aWYoY2g9PT0iIyIpe3N0cmVhbS5za2lwVG9FbmQoKTtyZXR1cm4gImNvbW1lbnQiO31pZihjaD09PSciJ3x8Y2g9PT0iJyIpe3ZhciBxPXN0cmVhbS5uZXh0KCk7dmFyIGVzYz1mYWxzZSxjO3doaWxlKChjPXN0cmVhbS5uZXh0KCkpIT1udWxsKXtpZihjPT09cSYmIWVzYyl7YnJlYWs7fWVzYz0oIWVzYyYmYz09PSJcXCIpO31yZXR1cm4gInN0cmluZyI7fWlmKC9bMC05XS8udGVzdChjaCkpe3N0cmVhbS5tYXRjaCgvXlxkKyg/OlwuXGQrKT8vKTtyZXR1cm4gIm51bWJlciI7fWlmKC9bQS1aYS16X10vLnRlc3QoY2gpKXt2YXIgbT1zdHJlYW0ubWF0Y2goL15bQS1aYS16X11bQS1aYS16MC05X10qLyk7dmFyIHdvcmQ9bVswXTtpZihLV1t3b3JkXSl7cmV0dXJuICJrZXl3b3JkIjt9aWYoQVRPTVt3b3JkXSl7cmV0dXJuICJhdG9tIjt9aWYoL15bQS1aXS8udGVzdCh3b3JkKSl7cmV0dXJuICJ2YXJpYWJsZS0yIjt9cmV0dXJuIG51bGw7fXN0cmVhbS5uZXh0KCk7cmV0dXJuIG51bGw7fX07fSk7Q29kZU1pcnJvci5fX2phY0RlZmluZWQ9dHJ1ZTt9KSgpOwo=";
    let s = document.createElement("script");
    s.textContent = window.atob(b64);
    document.head.appendChild(s);
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
}
async function load_script(src) {
  install_load_helper();
  await window.__loadScript(src);
}
function display_lang(lang) {
  let low = lang.toLowerCase();
  if ((low === "jac")) {
    return "Jac";
  }
  if (((low === "python") || (low === "py"))) {
    return "Python";
  }
  if (!lang) {
    return "Code";
  }
  return (lang.slice(0, 1).toUpperCase() + lang.slice(1));
}
async function enhance_code_blocks(container) {
  let pres = container.querySelectorAll("pre");
  let targets = [];
  for (const pre of pres) {
    if (pre.dataset.enhanced) {
      continue;
    }
    if ((pre.closest("div.runnable-jac") || pre.closest("div.code-block"))) {
      continue;
    }
    let code_el = (pre.querySelector("code") || pre);
    let cls_str = ((String(code_el.className) + " ") + String(pre.className));
    if ((cls_str.includes("language-mermaid") || cls_str.includes("mermaid"))) {
      continue;
    }
    targets.push(pre);
  }
  let has_any = false;
  for (const _t of targets) {
    has_any = true;
    break;
  }
  if (!has_any) {
    return;
  }
  await ensure_codemirror();
  if (!window.CodeMirror) {
    return;
  }
  for (const pre of targets) {
    pre.dataset.enhanced = "true";
    let code_el = (pre.querySelector("code") || pre);
    let source = _jac.str.rstrip(String(code_el.textContent), "\n");
    let lang = "";
    let classes = ((String(code_el.className) + " ") + String(pre.className)).split(" ");
    for (const raw_cls of classes) {
      let cls = String(raw_cls);
      if (cls.startsWith("language-")) {
        lang = cls.slice("language-".length);
        break;
      }
    }
    let shell = document.createElement("div");
    shell.className = "runnable-jac code-static";
    if (lang) {
      shell.className = `runnable-jac code-static lang-${lang.toLowerCase()}`;
    }
    let header = document.createElement("div");
    header.className = "runnable-header";
    let tag = document.createElement("span");
    tag.className = "code-lang";
    tag.textContent = display_lang(lang);
    header.appendChild(tag);
    let copy_btn = document.createElement("button");
    copy_btn.type = "button";
    copy_btn.className = "runnable-copy";
    copy_btn.textContent = "Copy";
    header.appendChild(copy_btn);
    shell.appendChild(header);
    let host = document.createElement("div");
    host.className = "runnable-editor-host";
    shell.appendChild(host);
    let outer = (pre.closest("div.highlight") || pre);
    outer.parentNode.insertBefore(shell, outer);
    outer.parentNode.removeChild(outer);
    let has_jac = false;
    try {
      has_jac = _jac.builtin.bool(window.CodeMirror.modes["jac"]);
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let _ignore = null;
      } else {
        throw __jac_e;
      }
    }
    let cm_mode = (has_jac ? "jac" : "null");
    let cm = window.CodeMirror(host, {"value": source, "mode": cm_mode, "theme": "default", "lineNumbers": true, "readOnly": true, "viewportMargin": 100000});
    copy_btn.addEventListener("click", make_copier(cm, copy_btn));
    setTimeout(() => cm.refresh(), 60);
  }
}
async function render_mermaid_blocks(container) {
  let targets = container.querySelectorAll(".mermaid-block:not([data-processed])");
  let has_any = false;
  for (const _t of targets) {
    has_any = true;
    break;
  }
  if (!has_any) {
    return;
  }
  if (!window.mermaid) {
    install_load_helper();
    try {
      await window.__loadMermaid();
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let _ignore = null;
      } else {
        throw __jac_e;
      }
    }
  }
  if (!window.mermaid) {
    return;
  }
  try {
    await document.fonts.ready;
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
  let i = 0;
  for (const el of targets) {
    if (el.getAttribute("data-processed")) {
      continue;
    }
    i = (i + 1);
    el.setAttribute("data-processed", "true");
    let source = String(el.textContent).trim();
    try {
      window.mermaid.initialize({"startOnLoad": false, "theme": "default", "securityLevel": "loose", "fontFamily": "Inter, system-ui, sans-serif"});
      let light_res = await window.mermaid.render(`mmd-l-${Date.now()}-${i}`, source);
      window.mermaid.initialize({"startOnLoad": false, "theme": "dark", "securityLevel": "loose", "fontFamily": "Inter, system-ui, sans-serif"});
      let dark_res = await window.mermaid.render(`mmd-d-${Date.now()}-${i}`, source);
      el.innerHTML = `<div class="mermaid-variant mermaid-variant-light">${light_res.svg}</div><div class="mermaid-variant mermaid-variant-dark">${dark_res.svg}</div>`;
      _jac.poly.call(el.classList, "add", "mermaid-rendered");
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        _jac.poly.call(el.classList, "add", "mermaid-error");
        el.textContent = `[mermaid error] ${e}`;
      } else {
        throw __jac_e;
      }
    }
  }
}
async function ensure_pyodide() {
  if (window.__pyodide) {
    return window.__pyodide;
  }
  if (!window.__pyodide_loading) {
    async function boot() {
      await load_script("https://cdn.jsdelivr.net/pyodide/v0.27.0/full/pyodide.js");
      let py = await window.loadPyodide({"indexURL": "https://cdn.jsdelivr.net/pyodide/v0.27.0/full/"});
      await py.loadPackage(["micropip"]);
      return py;
    }
    window.__pyodide_loading = boot();
  }
  let py = await window.__pyodide_loading;
  window.__pyodide = py;
  return py;
}
async function ensure_jaclang(py) {
  if (window.__jaclang_ready) {
    return;
  }
  await py.loadPackage(["micropip", "sqlite3"]);
  await py.runPythonAsync("\n    import micropip\n    await micropip.install(\"pluggy\")\n    ");
  let zip_result = await __jacSpawn("GetRuntimeZip", "", {});
  let b64 = "";
  if (_jac.builtin.bool(_jac.poly.and_(zip_result.reports, () => (zip_result.reports.length > 0)))) {
    let data = zip_result.reports[0];
    if (data["ok"]) {
      b64 = String(data["b64"]);
    }
  }
  if (!b64) {
    throw new _jac.exc.ValueError("could not load Jac runtime bundle");
  }
  py.globals.set("__zip_b64", b64);
  await py.runPythonAsync("\n    import base64, io, zipfile, sys, os\n    if not os.path.exists(\"/jaclang\"):\n        _raw = base64.b64decode(__zip_b64)\n        with zipfile.ZipFile(io.BytesIO(_raw), \"r\") as _z:\n            _z.extractall(\"/jaclang\")\n    if \"/jaclang\" not in sys.path:\n        sys.path.insert(0, \"/jaclang\")\n    from jaclang.cli.commands import execution\n    ");
  window.__jaclang_ready = true;
}
async function run_snippet(code, lang) {
  try {
    let py = await ensure_pyodide();
    py.globals.set("__src", code);
    if ((lang === "jac")) {
      await ensure_jaclang(py);
      await py.runPythonAsync("\n    import sys, io, os, traceback\n    # Monotonic, never-repeating module name. jaclang derives the module name from\n    # the file stem and caches it in sys.modules; a repeated stem (NamedTemporaryFile\n    # can recycle names in Pyodide's in-memory FS) makes it serve the FIRST program\n    # for every later run. A fresh stem each run guarantees the edited source runs.\n    _n = getattr(sys, \"_jac_run_n\", 0) + 1\n    sys._jac_run_n = _n\n    _mod = \"jac_run_%d\" % _n\n    _dir = \"/jac_runs\"\n    os.makedirs(_dir, exist_ok=True)\n    _path = os.path.join(_dir, _mod + \".jac\")\n    with open(_path, \"w\") as _f:\n        _f.write(__src)\n    sys.modules.pop(_mod, None)\n    # jaclang's program is a singleton; its errors_had/warnings_had lists persist\n    # across runs, so each run would re-print every earlier run's errors. Clear them.\n    try:\n        from jaclang.jac0core.runtime import JacRuntime as _Jac\n        _prog = _Jac.get_program()\n        _prog.errors_had.clear()\n        _prog.warnings_had.clear()\n    except Exception:\n        pass\n    _out = io.StringIO()\n    _orig_out, _orig_err = sys.stdout, sys.stderr\n    sys.stdout = _out\n    sys.stderr = _out\n    try:\n        from jaclang.cli.commands import execution\n        execution.run(_path, main=True, cache=False)\n    except SystemExit:\n        pass\n    except Exception:\n        traceback.print_exc()\n    finally:\n        sys.stdout = _orig_out\n        sys.stderr = _orig_err\n    ");
    } else {
      py.runPython("\n    import sys, io, traceback\n    _out = io.StringIO()\n    _orig_out, _orig_err = sys.stdout, sys.stderr\n    sys.stdout = _out\n    sys.stderr = _out\n    try:\n        exec(__src, {\"__name__\": \"__main__\"})\n    except Exception:\n        traceback.print_exc()\n    finally:\n        sys.stdout = _orig_out\n        sys.stderr = _orig_err\n    ");
    }
    let out = py.runPython("_out.getvalue()");
    return {"ok": true, "output": String(out)};
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let e = __jac_e;
      return {"ok": false, "output": String(e)};
    } else {
      throw __jac_e;
    }
  }
}
async function mount_runnable_blocks(container) {
  let blocks = container.querySelectorAll("div.code-block:not([data-runnable])");
  let has_any = false;
  for (const _b of blocks) {
    has_any = true;
    break;
  }
  if (!has_any) {
    return;
  }
  await ensure_codemirror();
  if (!window.CodeMirror) {
    return;
  }
  for (const block of blocks) {
    if (block.dataset.runnable) {
      continue;
    }
    block.dataset.runnable = "true";
    let lang = (block.getAttribute("data-lang") || "jac");
    let src_el = ((block.querySelector("pre code") || block.querySelector("code")) || block.querySelector("pre"));
    let source = (src_el ? String(src_el.textContent) : String(block.textContent));
    source = _jac.str.rstrip(source, "\n");
    block.innerHTML = "";
    block.className = "runnable-jac";
    let header = document.createElement("div");
    header.className = "runnable-header";
    let lang_el = document.createElement("span");
    lang_el.className = "code-lang";
    lang_el.textContent = display_lang(String(lang));
    header.appendChild(lang_el);
    let actions = document.createElement("div");
    actions.className = "runnable-actions";
    let copy_btn = document.createElement("button");
    copy_btn.type = "button";
    copy_btn.className = "runnable-copy";
    copy_btn.textContent = "Copy";
    actions.appendChild(copy_btn);
    let run_btn = document.createElement("button");
    run_btn.type = "button";
    run_btn.className = "runnable-run";
    run_btn.textContent = "\u25b6 Run";
    actions.appendChild(run_btn);
    header.appendChild(actions);
    block.appendChild(header);
    let host = document.createElement("div");
    host.className = "runnable-editor-host";
    block.appendChild(host);
    let has_jac = false;
    try {
      has_jac = _jac.builtin.bool(window.CodeMirror.modes["jac"]);
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let _ignore = null;
      } else {
        throw __jac_e;
      }
    }
    let cm_mode = (has_jac ? "jac" : "null");
    let cm = window.CodeMirror(host, {"value": source, "mode": cm_mode, "theme": "default", "lineNumbers": true, "indentUnit": 4, "viewportMargin": 100000});
    setTimeout(() => cm.refresh(), 60);
    let output = document.createElement("pre");
    output.className = "runnable-output";
    block.appendChild(output);
    copy_btn.addEventListener("click", make_copier(cm, copy_btn));
    run_btn.addEventListener("click", make_runner(cm, output, run_btn, String(lang)));
  }
}
function make_copier(cm, copy_btn) {
  function handler() {
    try {
      copy_text(String(cm.getValue()));
      copy_btn.textContent = "Copied \u2713";
      setTimeout(() => {
        copy_btn.textContent = "Copy";
      }, 1500);
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let _ignore = null;
      } else {
        throw __jac_e;
      }
    }
  }
  return handler;
}
function make_runner(cm, output, run_btn, lang) {
  async function handler() {
    run_btn.disabled = true;
    run_btn.textContent = "Running\u2026";
    output.dataset.kind = "running";
    output.textContent = "Loading runtime\u2026";
    try {
      let code = String(cm.getValue());
      let result = await run_snippet(code, lang);
      output.textContent = (result["output"] || "(no output)");
      output.dataset.kind = (result["ok"] ? "ok" : "error");
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        output.textContent = String(e);
        output.dataset.kind = "error";
      } else {
        throw __jac_e;
      }
    }
    run_btn.disabled = false;
    run_btn.textContent = "\u25b6 Run";
  }
  return handler;
}
function build_toc(container) {
  let items = [];
  let heads = container.querySelectorAll("h2[id], h3[id]");
  for (const h of heads) {
    let raw = String((h.textContent || ""));
    let link_el = h.querySelector(".headerlink");
    if (link_el) {
      raw = raw.replaceAll(String((link_el.textContent || "")), "");
    }
    let text = raw.trim();
    if (!text) {
      continue;
    }
    let level = ((String(h.tagName) === "H2") ? 2 : 3);
    items.push({"id": String(h.getAttribute("id")), "text": text, "level": level});
  }
  return items;
}
function setup_toc_scrollspy() {
  if (window.__tocScroll) {
    window.removeEventListener("scroll", window.__tocScroll);
  }
  function on_scroll() {
    let toc_el = document.querySelector(".post-toc");
    if (!toc_el) {
      return;
    }
    let prose_el = document.querySelector(".post-shell .prose");
    if (prose_el) {
      let rect = prose_el.getBoundingClientRect();
      let past_article = (rect.bottom < 160);
      if (past_article) {
        _jac.poly.call(toc_el.classList, "add", "post-toc-hidden");
      } else {
        _jac.poly.call(toc_el.classList, "remove", "post-toc-hidden");
      }
    }
    let links = toc_el.querySelectorAll("a[data-toc-id]");
    let current = "";
    for (const ln of links) {
      let target = document.getElementById(String(ln.getAttribute("data-toc-id")));
      if ((target && (target.getBoundingClientRect().top <= 140))) {
        current = String(ln.getAttribute("data-toc-id"));
      }
    }
    for (const ln of links) {
      if ((current && (String(ln.getAttribute("data-toc-id")) === current))) {
        _jac.poly.call(ln.classList, "add", "is-active");
      } else {
        _jac.poly.call(ln.classList, "remove", "is-active");
      }
    }
  }
  window.__tocScroll = on_scroll;
  window.addEventListener("scroll", on_scroll, {"passive": true});
  setTimeout(on_scroll, 60);
}
let LINK_RAIL_SKIP = ["jaseci.org", "blogs.jaseci.org", "jac-lang.org", "jaclang.org"];
function classify_link(href) {
  let blank = {"type": "", "host": ""};
  let parser = document.createElement("a");
  parser.href = href;
  let proto = String((parser.protocol || ""));
  if (((proto !== "http:") && (proto !== "https:"))) {
    return blank;
  }
  let host = String((parser.hostname || "")).toLowerCase();
  if (host.startsWith("www.")) {
    host = host.slice(4);
  }
  let cur = String((window.location.hostname || "")).toLowerCase();
  if ((((host === cur) || LINK_RAIL_SKIP.includes(host)) || host.endsWith(".jaseci.org"))) {
    return blank;
  }
  let segs = String((parser.pathname || "")).split("/").filter(s => s).map(s => s);
  if (((host === "github.com") && (segs.length >= 2))) {
    return {"type": "github", "host": host};
  }
  if (["youtube.com", "m.youtube.com", "youtu.be"].includes(host)) {
    return {"type": "youtube", "host": host};
  }
  return {"type": "link", "host": host};
}
function build_link_rail(container) {
  let out = [];
  let els = container.querySelectorAll("a[href], iframe[src]");
  let seen = {};
  let i = 0;
  for (const el of els) {
    let is_iframe = (String((el.tagName || "")).toUpperCase() === "IFRAME");
    if ((!is_iframe && el.classList.contains("headerlink"))) {
      continue;
    }
    let raw = String(((is_iframe ? el.getAttribute("src") : el.getAttribute("href")) || ""));
    if (!raw) {
      continue;
    }
    let info = classify_link(raw);
    if (!info["type"]) {
      continue;
    }
    if ((is_iframe && (String(info["type"]) !== "youtube"))) {
      continue;
    }
    let resolved = String(((is_iframe ? el.src : el.href) || raw));
    if ((resolved in seen)) {
      continue;
    }
    seen[resolved] = true;
    let existing = String((el.getAttribute("id") || ""));
    let ref_id = (existing ? existing : ("lnk-" + String(i)));
    if (!existing) {
      el.setAttribute("id", ref_id);
    }
    out.push({"id": ref_id, "type": String(info["type"]), "href": resolved, "host": String(info["host"])});
    i = (i + 1);
  }
  return out;
}
function setup_link_rail_scrollspy() {
  if (window.__linkRailScroll) {
    window.removeEventListener("scroll", window.__linkRailScroll);
  }
  function on_scroll() {
    let rail = document.querySelector(".link-rail");
    if (!rail) {
      return;
    }
    let prose_el = document.querySelector(".post-shell .prose");
    if (prose_el) {
      if ((prose_el.getBoundingClientRect().bottom < 160)) {
        _jac.poly.call(rail.classList, "add", "link-rail-hidden");
      } else {
        _jac.poly.call(rail.classList, "remove", "link-rail-hidden");
      }
    }
    let nodes = rail.querySelectorAll(".link-node");
    let line = (window.innerHeight * 0.4);
    let active = (-1);
    let best = (-1000000.0);
    let idx = 0;
    for (const el of nodes) {
      let ref = String((el.getAttribute("data-link-id") || ""));
      let target = document.getElementById(ref);
      if (target) {
        let top = target.getBoundingClientRect().top;
        if (((top <= line) && (top > best))) {
          best = top;
          active = idx;
        }
      }
      idx = (idx + 1);
    }
    let focus = ((active >= 0) ? active : 0);
    let idx2 = 0;
    for (const el of nodes) {
      if ((idx2 === active)) {
        _jac.poly.call(el.classList, "add", "is-active");
      } else {
        _jac.poly.call(el.classList, "remove", "is-active");
      }
      if ((Math.abs((idx2 - focus)) <= 1)) {
        _jac.poly.call(el.classList, "add", "is-expanded");
      } else {
        _jac.poly.call(el.classList, "remove", "is-expanded");
      }
      idx2 = (idx2 + 1);
    }
  }
  window.__linkRailScroll = on_scroll;
  window.addEventListener("scroll", on_scroll, {"passive": true});
  setTimeout(on_scroll, 80);
}
function favicon_url(host) {
  return (("https://www.google.com/s2/favicons?domain=" + host) + "&sz=64");
}
function Render_link_card(props) {
  const {item, meta} = props;
  let t = String(item["type"]);
  let href = String(item["href"]);
  let host = String(item["host"]);
  let title = "";
  let desc = "";
  let vid = "";
  let img = "";
  let stars = 0;
  if (meta) {
    title = String((_jac.poly.call(meta, "get", "title") || ""));
    desc = String((_jac.poly.call(meta, "get", "description") || ""));
    vid = String((_jac.poly.call(meta, "get", "video_id") || ""));
    img = String((_jac.poly.call(meta, "get", "image") || ""));
    stars = (_jac.poly.call(meta, "get", "stars") || 0);
  }
  if ((t === "youtube")) {
    let watch = (vid ? ("https://www.youtube.com/watch?v=" + vid) : href);
    return __jacJsx("a", {"className": "link-card-link link-card-media", "href": watch, "target": "_blank", "rel": "noopener noreferrer"}, [(img && __jacJsx("span", {"className": "link-thumb"}, [__jacJsx("img", {"src": img, "alt": "", "loading": "lazy"}, []), __jacJsx("span", {"className": "link-thumb-play"}, ["▶"])])), __jacJsx("span", {"className": "link-card-host"}, ["YouTube"]), __jacJsx("span", {"className": "link-card-title"}, [(title || "YouTube video")])]);
  }
  let label = ((t === "github") ? "GitHub" : host);
  return __jacJsx("a", {"className": "link-card-link", "href": href, "target": "_blank", "rel": "noopener noreferrer"}, [__jacJsx("span", {"className": "link-card-host"}, [label]), __jacJsx("span", {"className": "link-card-title"}, [(title || host)]), (desc && __jacJsx("span", {"className": "link-card-desc"}, [desc])), (((t === "github") && (stars > 0)) && __jacJsx("span", {"className": "link-card-meta"}, [("\u2605 " + String(stars))]))]);
}
const render_link_card = Render_link_card;
function Render_repost_card(props) {
  const {post, fallback_img: fallback_img = ""} = props;
  let url = String(post["repost_url"]);
  let meta = (post["repost_meta"] || {});
  let host = String((_jac.poly.call(meta, "get", "host") || ""));
  if (!host) {
    let parser = document.createElement("a");
    parser.href = url;
    host = String((parser.hostname || "")).toLowerCase();
    if (host.startsWith("www.")) {
      host = host.slice(4);
    }
  }
  let source = ((String(post["repost_source"]) || host) || "the original site");
  let ext_title = String((_jac.poly.call(meta, "get", "title") || ""));
  let ext_desc = String((_jac.poly.call(meta, "get", "description") || ""));
  let img = (String((_jac.poly.call(meta, "get", "image") || "")) || fallback_img);
  return __jacJsx("aside", {"className": "repost-card"}, [__jacJsx("a", {"className": "repost-card-link", "href": url, "target": "_blank", "rel": "noopener noreferrer"}, [(img && __jacJsx("span", {"className": "repost-card-thumb"}, [__jacJsx("img", {"src": img, "alt": "", "loading": "lazy"}, [])])), __jacJsx("span", {"className": "repost-card-body"}, [__jacJsx("span", {"className": "repost-card-eyebrow"}, [(host && __jacJsx("img", {"className": "repost-card-favicon", "src": favicon_url(host), "alt": "", "width": 16, "height": 16, "loading": "lazy"}, [])), __jacJsx("span", {}, [("Reposted from " + source)])]), (ext_title && __jacJsx("span", {"className": "repost-card-title"}, [ext_title])), (ext_desc && __jacJsx("span", {"className": "repost-card-desc"}, [ext_desc])), __jacJsx("span", {"className": "repost-card-cta"}, [(("Read the original on " + (host || source)) + " \u2192")])])])]);
}
const render_repost_card = Render_repost_card;
function analytics_visitor_id() {
  try {
    let existing = window.localStorage.getItem("jaseci-blog-vid");
    if (existing) {
      return String(existing);
    }
    let fresh = "";
    try {
      fresh = String(window.crypto.randomUUID());
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        fresh = ("v-" + String(Math.trunc(Number(Date.now()))));
      } else {
        throw __jac_e;
      }
    }
    window.localStorage.setItem("jaseci-blog-vid", fresh);
    return fresh;
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      return "";
    } else {
      throw __jac_e;
    }
  }
}
async function record_view(slug) {
  try {
    await __jacSpawn("RecordView", "", {"slug": String(slug), "visitor": analytics_visitor_id()});
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
}
async function record_link_click(slug, href) {
  try {
    await __jacSpawn("RecordLinkClick", "", {"slug": String(slug), "href": String(href)});
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
}
async function flush_engagement() {
  try {
    let st = window.__blogTrack;
    if (((!st || st["sent"]) || !st["slug"])) {
      return;
    }
    let now = Math.trunc(Number(Date.now()));
    if ((st["resume"] > 0)) {
      st["active"] = (st["active"] + (now - st["resume"]));
      st["resume"] = 0;
    }
    if (((st["active"] < 1000) && (st["maxScroll"] < 25))) {
      return;
    }
    st["sent"] = true;
    await __jacSpawn("RecordEngagement", "", {"slug": String(st["slug"]), "dwell_ms": parseFloat(st["active"]), "scroll_pct": Math.trunc(Number(st["maxScroll"]))});
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
}
function compute_scroll_pct(container) {
  try {
    let rect = container.getBoundingClientRect();
    let height = container.offsetHeight;
    if ((height <= 0)) {
      return 0;
    }
    let abs_top = (rect.top + window.scrollY);
    let reached = ((window.scrollY + window.innerHeight) - abs_top);
    let pct = ((reached / height) * 100.0);
    if ((pct < 0)) {
      return 0;
    }
    if ((pct > 100)) {
      return 100;
    }
    return Math.trunc(Number(pct));
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      return 0;
    } else {
      throw __jac_e;
    }
  }
}
function setup_engagement_tracking(container, slug) {
  try {
    let prev = window.__blogTrack;
    if (((prev && (prev["slug"] === slug)) && !prev["sent"])) {
      return;
    }
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
  flush_engagement();
  let visible = true;
  try {
    visible = (document.visibilityState !== "hidden");
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
  window.__blogTrack = {"slug": slug, "active": 0, "resume": (visible ? Math.trunc(Number(Date.now())) : 0), "maxScroll": 0, "sent": false};
  try {
    if (window.__blogScrollTrack) {
      window.removeEventListener("scroll", window.__blogScrollTrack);
    }
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
  function on_scroll() {
    let st = window.__blogTrack;
    if (!st) {
      return;
    }
    let p = compute_scroll_pct(container);
    if ((p > st["maxScroll"])) {
      st["maxScroll"] = p;
    }
  }
  window.__blogScrollTrack = on_scroll;
  window.addEventListener("scroll", on_scroll, {"passive": true});
  setTimeout(on_scroll, 60);
  try {
    if (window.__blogVisTrack) {
      document.removeEventListener("visibilitychange", window.__blogVisTrack);
    }
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
  function on_vis() {
    let st = window.__blogTrack;
    if (!st) {
      return;
    }
    let now = Math.trunc(Number(Date.now()));
    if ((document.visibilityState === "hidden")) {
      if ((st["resume"] > 0)) {
        st["active"] = (st["active"] + (now - st["resume"]));
        st["resume"] = 0;
      }
    } else if ((st["resume"] === 0)) {
      st["resume"] = now;
    }
  }
  window.__blogVisTrack = on_vis;
  document.addEventListener("visibilitychange", on_vis);
  try {
    if (window.__blogHideTrack) {
      window.removeEventListener("pagehide", window.__blogHideTrack);
    }
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
  function on_hide() {
    flush_engagement();
  }
  window.__blogHideTrack = on_hide;
  window.addEventListener("pagehide", on_hide);
  function on_link_click(e) {
    try {
      let anchor = e.target.closest("a");
      if (anchor) {
        let href = anchor.getAttribute("href");
        if ((href && !String(href).startsWith("#"))) {
          record_link_click(slug, String(href));
        }
      }
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let _ignore = null;
      } else {
        throw __jac_e;
      }
    }
  }
  container.addEventListener("click", on_link_click);
}
function PostBody(props) {
  const {html, slug} = props;
  let ref = useRef(null);
  const [html_version, setHtml_version] = useState(0);
  const [toc, setToc] = useState([]);
  const [links, setLinks] = useState([]);
  const [link_meta, setLink_meta] = useState({});
  useEffect(() => {
    setHtml_version((html_version + 1));
  }, [html]);
  useEffect(() => {
    return () => {
      flush_engagement();
    };
  }, []);
  useEffect(() => {
    (async () => {
      if (!ref.current) {
        return;
      }
      let container = ref.current;
      try {
        await mount_runnable_blocks(container);
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let _ignore = null;
        } else {
          throw __jac_e;
        }
      }
      try {
        await enhance_code_blocks(container);
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let _ignore = null;
        } else {
          throw __jac_e;
        }
      }
      try {
        await render_mermaid_blocks(container);
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let _ignore = null;
        } else {
          throw __jac_e;
        }
      }
      try {
        setToc(build_toc(container));
        setup_toc_scrollspy();
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let _ignore = null;
        } else {
          throw __jac_e;
        }
      }
      try {
        let found = build_link_rail(container);
        setLinks(found);
        setup_link_rail_scrollspy();
        let urls = [];
        let seen = {};
        for (const lk of found) {
          let href = String(lk["href"]);
          if (!(href in seen)) {
            seen[href] = true;
            urls.push(href);
          }
        }
        if (_jac.builtin.bool(urls)) {
          let resp = await __jacSpawn("FetchLinkMeta", "", {"urls": urls});
          if (_jac.builtin.bool(_jac.poly.and_(resp.reports, () => (resp.reports.length > 0)))) {
            let rep = resp.reports[0];
            let metas = (_jac.poly.contains(rep, "meta") ? rep["meta"] : []);
            let mp = {};
            for (const m of metas) {
              mp[String(m["url"])] = m;
            }
            setLink_meta(mp);
          }
        }
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let _ignore = null;
        } else {
          throw __jac_e;
        }
      }
      try {
        setup_engagement_tracking(container, String(slug));
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let _ignore = null;
        } else {
          throw __jac_e;
        }
      }
    })();
  }, [html_version]);
  return __jacJsx(null, {}, [((toc.length > 1) && __jacJsx("nav", {"className": "post-toc", "aria-label": "On this page"}, [__jacJsx("p", {"className": "post-toc-title"}, ["On this page"]), __jacJsx("ul", {"className": "post-toc-list"}, [toc.map(item => __jacJsx("li", {"key": item["id"], "className": `post-toc-item post-toc-l${item["level"]}`}, [__jacJsx("a", {"href": `#${item["id"]}`, "data-toc-id": item["id"], "className": "post-toc-link"}, [item["text"]])]))])])), __jacJsx("div", {"ref": ref, "className": "prose", "dangerouslySetInnerHTML": {"__html": html}}, []), ((links.length > 0) && __jacJsx("nav", {"className": "link-rail", "aria-label": "References in this post"}, [links.map(item => __jacJsx("div", {"className": `link-node link-node-${item["type"]}`, "data-link-id": item["id"], "key": item["id"]}, [__jacJsx("span", {"className": "link-dot"}, [__jacJsx("img", {"className": "link-dot-img", "src": favicon_url(String(item["host"])), "alt": "", "loading": "lazy"}, [])]), __jacJsx("div", {"className": "link-card"}, [render_link_card({item: item, meta: (link_meta[item["href"]] ?? undefined)})])]))]))]);
}
function Page() {
  let params = useParams();
  let slug = params["slug"];
  const [loading, setLoading] = useState(true);
  const [post, setPost] = useState(null);
  const [error, setError] = useState("");
  const [status, setStatus] = useState("");
  const [pending_title, setPending_title] = useState("");
  const [share_copied, setShare_copied] = useState(false);
  const [share_open, setShare_open] = useState(false);
  const [repost_img, setRepost_img] = useState("");
  useEffect(() => {
    (async () => {
      window.scrollTo(0, 0);
      setLoading(true);
      setError("");
      setStatus("");
      setPending_title("");
      setPost(null);
      setRepost_img("");
      let unfurl_url = "";
      let start = Math.trunc(Number(Date.now()));
      let preview_token = "";
      try {
        let search = String((window.location.search || ""));
        if (search.startsWith("?")) {
          search = search.slice(1);
        }
        for (const pair of search.split("&")) {
          if (pair.startsWith("preview=")) {
            preview_token = _jac.str.split(pair, "=", 1)[1];
          }
        }
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let _ignore = null;
        } else {
          throw __jac_e;
        }
      }
      try {
        let result = await __jacSpawn("GetPost", "", {"slug": String(slug), "preview": preview_token});
        if (_jac.builtin.bool(_jac.poly.and_(result.reports, () => (result.reports.length > 0)))) {
          let data = result.reports[0];
          if (data["ok"]) {
            setPost(data);
            try {
              record_view(String(data["slug"]));
            } catch (__jac_e) {
              if (_jac.exc.matches(__jac_e, "Exception")) {
                let _ignore = null;
              } else {
                throw __jac_e;
              }
            }
            document.title = `${data["title"]} · Jaseci Blogs`;
            let meta_desc = (String(data["description"]) || `${data["reading_minutes"]} min read on Jaseci Blogs.`);
            let meta_url = "";
            try {
              meta_url = String(window.location.href);
            } catch (__jac_e) {
              if (_jac.exc.matches(__jac_e, "Exception")) {
                let _ignore = null;
              } else {
                throw __jac_e;
              }
            }
            set_social_meta(String(data["title"]), meta_desc, meta_url, String(data["cover"]));
            if (_jac.builtin.bool(data["is_repost"])) {
              let rmeta_l = (data["repost_meta"] || {});
              if (!String((_jac.poly.call(rmeta_l, "get", "image") || ""))) {
                unfurl_url = String((data["repost_url"] || ""));
              }
            }
          } else {
            setError(String(data["error"]));
            let new_status = String(data["status"]);
            setStatus(new_status);
            if ((new_status === "coming_soon")) {
              setPending_title(String(data["title"]));
            }
          }
        } else {
          setError("No response from server.");
        }
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          setError("Network error.");
        } else {
          throw __jac_e;
        }
      }
      let min_ms = 750;
      try {
        min_ms = Math.trunc(Number(window.__BLOG_CONFIG["minLoadingMs"]));
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let _ignore = null;
        } else {
          throw __jac_e;
        }
      }
      let remaining = (min_ms - (Math.trunc(Number(Date.now())) - start));
      if ((remaining > 0)) {
        setTimeout(() => {
          setLoading(false);
        }, remaining);
      } else {
        setLoading(false);
      }
      if (unfurl_url) {
        try {
          let api = `https://api.microlink.io/?url=${encodeURIComponent(unfurl_url)}`;
          let resp = await fetch(api);
          let jd = await resp.json();
          if ((String(jd["status"]) === "success")) {
            let d = jd["data"];
            let im = d["image"];
            let got = (im ? String(im["url"]) : "");
            if (got) {
              setRepost_img(got);
            }
          }
        } catch (__jac_e) {
          if (_jac.exc.matches(__jac_e, "Exception")) {
            let _ignore = null;
          } else {
            throw __jac_e;
          }
        }
      }
    })();
  }, [slug]);
  if (loading) {
    return __jacJsx(null, {}, [__jacJsx("div", {"className": "route-progress"}, []), __jacJsx("article", {"className": "post-shell"}, [__jacJsx("header", {"className": "post-header"}, [__jacJsx("div", {"className": "container narrow"}, [__jacJsx("span", {"className": "skeleton skeleton-line short"}, []), __jacJsx("span", {"className": "skeleton skeleton-title", "style": {"height": "3.5rem", "width": "95%"}}, []), __jacJsx("span", {"className": "skeleton skeleton-line long"}, []), __jacJsx("span", {"className": "skeleton skeleton-line medium"}, []), __jacJsx("div", {"className": "post-byline", "style": {"borderColor": "var(--rule)"}}, [__jacJsx("span", {"className": "skeleton skeleton-avatar round"}, []), __jacJsx("span", {"className": "skeleton skeleton-line short"}, [])])])]), __jacJsx("div", {"className": "container narrow"}, [__jacJsx("span", {"className": "skeleton skeleton-line full"}, []), __jacJsx("span", {"className": "skeleton skeleton-line full"}, []), __jacJsx("span", {"className": "skeleton skeleton-line long"}, []), __jacJsx("span", {"className": "skeleton skeleton-line medium"}, []), __jacJsx("span", {"className": "skeleton skeleton-block"}, []), __jacJsx("span", {"className": "skeleton skeleton-line full"}, []), __jacJsx("span", {"className": "skeleton skeleton-line full"}, []), __jacJsx("span", {"className": "skeleton skeleton-line long"}, [])])])]);
  }
  if ((status === "coming_soon")) {
    return __jacJsx("article", {"className": "post-shell"}, [__jacJsx("div", {"className": "container narrow", "style": {"padding": "4rem 0"}}, [__jacJsx("p", {"className": "eyebrow"}, ["Coming soon"]), __jacJsx("h1", {"className": "display"}, [(pending_title || "This post isn't live yet")]), __jacJsx("p", {"className": "post-deck"}, ["This post is in the editorial pipeline and hasn't been published yet. This link is permanent — it'll open the full article once the post goes live."]), __jacJsx("p", {"style": {"marginTop": "2rem"}}, [__jacJsx(Link, {"className": "cta-pill", "to": "/blog"}, ["← Back to latest"])])])]);
  }
  if (error) {
    let is_missing = (status === "not_found");
    return __jacJsx("article", {"className": "post-shell"}, [__jacJsx("div", {"className": "container narrow", "style": {"padding": "4rem 0"}}, [__jacJsx("p", {"className": "eyebrow"}, [((is_missing && "404") || "Couldn't load this post")]), __jacJsx("h1", {"className": "display"}, [((is_missing && "Post not found") || error)]), (is_missing && __jacJsx("p", {"className": "post-deck"}, ["This post doesn't exist. It may have been renamed, retired, or never published."])), __jacJsx("p", {"style": {"marginTop": "2rem"}}, [__jacJsx(Link, {"className": "cta-pill", "to": "/blog"}, ["← Back to latest"])])])]);
  }
  let cats = (post["categories"] || []);
  let primary_category = (cats ? cats[0] : "");
  let related = (post["related"] || []);
  let share_url = "";
  try {
    share_url = String(window.location.href);
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
  let enc_url = encodeURIComponent(share_url);
  let enc_title = encodeURIComponent(String(post["title"]));
  let x_url = `https://twitter.com/intent/tweet?url=${enc_url}&text=${enc_title}`;
  let fb_url = `https://www.facebook.com/sharer/sharer.php?u=${enc_url}`;
  let li_url = `https://www.linkedin.com/sharing/share-offsite/?url=${enc_url}`;
  let share_text = `${post["title"]} — ${share_url}`;
  return __jacJsx("article", {"className": "post-shell"}, [(post["is_preview"] && __jacJsx("div", {"className": "preview-banner"}, [__jacJsx("p", {"className": "container narrow small", "style": {"margin": "0", "color": "var(--text-muted)"}}, ["👁 Draft preview — not published. This link is private and expires in ~1 month."])])), __jacJsx("header", {"className": "post-header"}, [__jacJsx("div", {"className": "container narrow"}, [(primary_category && __jacJsx("p", {"className": "eyebrow"}, [__jacJsx(Link, {"to": `/blog/categories/${primary_category}`}, [primary_category])])), __jacJsx("h1", {"className": "post-title"}, [post["title"]]), (post["description"] && __jacJsx("p", {"className": "post-deck"}, [post["description"]])), __jacJsx("div", {"className": "post-byline"}, [__jacJsx("div", {"className": "byline-authors"}, [post["authors"].map(author => __jacJsx(Link, {"key": author["id"], "to": `/blog/authors/${author["id"]}`, "className": "byline-author"}, [(author["avatar"] && __jacJsx("img", {"src": author["avatar"], "alt": "", "width": 28, "height": 28, "className": "byline-avatar"}, [])), __jacJsx("span", {}, [author["name"]])]))]), __jacJsx("div", {"className": "byline-meta muted"}, [__jacJsx("span", {}, [post["date_long"]]), __jacJsx("span", {"className": "dot"}, ["·"]), __jacJsx("span", {}, [post["reading_minutes"], " min read"])]), __jacJsx("button", {"type": "button", "className": "share-trigger", "onClick": () => {
    setShare_open(true);
    try {
      copy_text(share_text);
      setShare_copied(true);
      setTimeout(() => {
        setShare_copied(false);
      }, 2200);
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let _ignore = null;
      } else {
        throw __jac_e;
      }
    }
  }, "aria-label": "Share this post"}, [__jacJsx("svg", {"width": "16", "height": "16", "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round"}, [__jacJsx("circle", {"cx": "18", "cy": "5", "r": "3"}, []), __jacJsx("circle", {"cx": "6", "cy": "12", "r": "3"}, []), __jacJsx("circle", {"cx": "18", "cy": "19", "r": "3"}, []), __jacJsx("line", {"x1": "8.59", "y1": "13.51", "x2": "15.42", "y2": "17.49"}, []), __jacJsx("line", {"x1": "15.41", "y1": "6.51", "x2": "8.59", "y2": "10.49"}, [])]), __jacJsx("span", {}, ["Share"])])])])]), (share_open && __jacJsx("div", {"className": "share-modal-overlay", "onClick": () => {
    setShare_open(false);
  }}, [__jacJsx("div", {"className": "share-modal-card", "onClick": e => e.stopPropagation()}, [__jacJsx("button", {"type": "button", "className": "share-modal-close", "onClick": () => {
    setShare_open(false);
  }, "aria-label": "Close"}, ["×"]), __jacJsx("p", {"className": "eyebrow"}, ["Share this post"]), __jacJsx("h3", {"className": "share-modal-title"}, [post["title"]]), __jacJsx("div", {"className": "share-preview"}, [__jacJsx("p", {"className": "share-preview-text"}, [share_text]), __jacJsx("span", {"className": "share-preview-badge"}, [((share_copied && "Copied to clipboard \u2713") || "Ready to paste")])]), __jacJsx("div", {"className": "share-buttons"}, [__jacJsx("a", {"className": "share-btn", "href": x_url, "target": "_blank", "rel": "noopener", "aria-label": "Share on X", "title": "X"}, [__jacJsx("svg", {"width": "20", "height": "20", "viewBox": "0 0 24 24", "fill": "currentColor"}, [__jacJsx("path", {"d": "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"}, [])])]), __jacJsx("a", {"className": "share-btn", "href": fb_url, "target": "_blank", "rel": "noopener", "aria-label": "Share on Facebook", "title": "Facebook"}, [__jacJsx("svg", {"width": "20", "height": "20", "viewBox": "0 0 24 24", "fill": "currentColor"}, [__jacJsx("path", {"d": "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"}, [])])]), __jacJsx("a", {"className": "share-btn", "href": li_url, "target": "_blank", "rel": "noopener", "aria-label": "Share on LinkedIn", "title": "LinkedIn"}, [__jacJsx("svg", {"width": "20", "height": "20", "viewBox": "0 0 24 24", "fill": "currentColor"}, [__jacJsx("path", {"d": "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"}, [])])]), __jacJsx("button", {"type": "button", "className": "share-btn", "aria-label": "Copy link for Instagram", "title": "Instagram (copies link)", "onClick": () => {
    try {
      copy_text(share_url);
      setShare_copied(true);
      setTimeout(() => {
        setShare_copied(false);
      }, 1800);
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let _ignore = null;
      } else {
        throw __jac_e;
      }
    }
  }}, [__jacJsx("svg", {"width": "20", "height": "20", "viewBox": "0 0 24 24", "fill": "currentColor"}, [__jacJsx("path", {"d": "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"}, [])])])]), __jacJsx("div", {"className": "share-link-row"}, [__jacJsx("input", {"type": "text", "className": "share-link-input", "readOnly": true, "value": share_url, "onClick": e => {
    let tgt = e.target;
    tgt.select();
  }}, []), __jacJsx("button", {"type": "button", "className": "share-link-copy", "onClick": () => {
    try {
      copy_text(share_url);
      setShare_copied(true);
      setTimeout(() => {
        setShare_copied(false);
      }, 1800);
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let _ignore = null;
      } else {
        throw __jac_e;
      }
    }
  }}, [((share_copied && "Copied \u2713") || "Copy")])]), __jacJsx("button", {"type": "button", "className": "share-copy-link", "onClick": () => {
    try {
      copy_text(share_text);
      setShare_copied(true);
      setTimeout(() => {
        setShare_copied(false);
      }, 1800);
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let _ignore = null;
      } else {
        throw __jac_e;
      }
    }
  }}, [((share_copied && "Copied \u2713") || "Copy title + link")])])])), (post["is_repost"] && __jacJsx("div", {"className": "container narrow"}, [render_repost_card({post: post, fallback_img: repost_img})])), (post["cover"] && __jacJsx("figure", {"className": "post-cover"}, [__jacJsx("img", {"src": post["cover"], "alt": ""}, [])])), __jacJsx("div", {"className": "container narrow"}, [__jacJsx(PostBody, {"html": post["html"], "slug": String(post["slug"])}, [])]), (cats && __jacJsx("div", {"className": "container narrow"}, [__jacJsx("ul", {"className": "tag-row"}, [cats.map(cat => __jacJsx("li", {"key": cat}, [__jacJsx(Link, {"to": `/blog/categories/${cat}`, "className": "tag"}, [cat])]))])])), __jacJsx("div", {"className": "container narrow"}, [__jacJsx("hr", {"className": "post-rule"}, []), __jacJsx("nav", {"className": "post-nav", "aria-label": "Adjacent posts"}, [((post["prev"] && __jacJsx(Link, {"to": `/blog/posts/${post["prev"]["slug"]}`, "className": "post-nav-link prev"}, [__jacJsx("span", {"className": "eyebrow"}, ["← Previous"]), __jacJsx("span", {"className": "post-nav-title"}, [post["prev"]["title"]])])) || __jacJsx("span", {}, [])), ((post["next"] && __jacJsx(Link, {"to": `/blog/posts/${post["next"]["slug"]}`, "className": "post-nav-link next"}, [__jacJsx("span", {"className": "eyebrow"}, ["Next →"]), __jacJsx("span", {"className": "post-nav-title"}, [post["next"]["title"]])])) || __jacJsx("span", {}, []))])]), (related && __jacJsx("section", {"className": "post-related"}, [__jacJsx("div", {"className": "container"}, [__jacJsx("p", {"className": "eyebrow"}, ["Related reading"]), __jacJsx("ul", {"className": "related-grid"}, [related.map(rel => __jacJsx("li", {"key": rel["slug"], "className": "related-card"}, [__jacJsx(Link, {"to": `/blog/posts/${rel["slug"]}`}, [__jacJsx("p", {"className": "related-title"}, [rel["title"]]), __jacJsx("p", {"className": "muted small"}, [rel["date_short"], " · ", rel["reading_minutes"], " min"])])]))])])]))]);
}
const page = Page;
/*jac:refresh-boundary*/;
export {PostBody, page};
//# sourceMappingURL=[slug].js.map
